import React from "react";
import {
    Tabs,
    Modal,
    Empty,
    Spin,
    Input,
    message,
    Pagination,
    Button,
    Col,
    DatePicker,
} from "antd";
import Layout from "@/Layout";
import Router from "next/router";
import { get, post } from "$ACTIONS/TlcRequest";
import { ApiPort, CMSAPIUrl } from "$ACTIONS/TLCAPI";
import {
    mailConversion,
    numberConversion,
    checksObjectHasValue,
} from "$ACTIONS/util";
import {
    getQueryVariable,
    getE2BBValue,
    showSmallResultModal,
    isWebPSupported,
    getDisplayPublicError,
} from "$ACTIONS/helper";
import {
    GetWalletList,
    GetWalletBonus,
    TransferSubmit,
    GetAllBalance,
} from "$DATA/wallet";
import RealyName from "@/RealyName";
import Announcement from "@/Announcement";
import AppliedHistory from "@/MyPromotionTabs/AppliedHistory";
import MyRebate from "@/MyPromotion/MyRebate";
import PromotionStatusButton from "@/MyPromotion/PromotionStatusButton";
import dynamic from "next/dynamic";
import moment from "moment";
import { AppliedDataModal, TransferModal } from "@/MyPromotionTabs/Modal";
import { connect, Provider } from "react-redux";
import store from "$STORE/store";
import { promotionActions } from "$STORE/promotionSlice";
import { userCenterActions } from "$STORE/userCenterSlice";
import {
    getAllPromotionRelatedDataAction,
    getPromotionListAction,
    updateBonusPromotionHistoryAction,
    changeTabAction,
} from "$STORE/thunk/promotionThunk";
import { getPromotionCategories } from "$ACTIONS/promotionRequest";
import ImageWithFallback from "@/ImageWithFallback/";
import { translate } from "$ACTIONS/Translate";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";
import { pathNameList } from "$DATA/me.static";
import SelfExclusionModal from "../components/SelfExclusionModal";
import { GetAppliedHistory, PromotionDetail } from "../actions/cmsApi";
import { fetchMemberSelfExlusionStatus } from "../store/userCenterSlice";
import { setSmarticoLoginContinue } from "../store/thunk/gameThunk";
import AppliedHistoryCardOneWallet from "../components/MyPromotionTabs/AppliedHistoryCardOneWallet";
import {
    checkManualBonusEligibility,
    GetBonusAssignedClaims,
    getCampaignAssignedClaims,
    HandleManalPreBonuseErrorModule,
    HandleReloadErrorModule,
} from "../data/wallet";
import PromotionOneWalletModal from "./PromotionOneWalletModal";
import promotionErrorConfigModule from "../components/promotionModalConfigModule";
import AppliedInProgressPromotionCard from "../components/MyPromotion/AppliedInProgressPromotionCard";
import Newbie from "../components/UI/Newbie";
import OneWalletPromotionPageButton from "../components/MyPromotion/OneWalletPromotionPageButton";
import AssinedClaimedBonusCard from "../components/MyPromotion/AssignedClaimedBonusCard";
import {
    enumBonusStatus,
    enumWalletProductGroupId,
} from "../actions/constantsData";
import {
    getEndDayOfMonth,
    getStartEndDateByNow,
    pageData,
    showErrorToast,
    showSuccessToast,
} from "../actions/helper";
import CustomizedToast from "../components/CustomizedToaster";
import AppliedClaimablePromotionCard from "../components/MyPromotion/AppliedClaimablePromotionCard";
import AppliedCompletePromotionCard from "../components/MyPromotion/AppliedCompletePromotionCard";
import {
    CallFnWhenEmpty,
    piwikBonus,
    piwikPromotion,
} from "../actions/piwikUtil";
import { toast, Zoom } from "react-toastify";
import { filter } from "lodash";
import Datepicker25 from "../components/DatePicker25";

import { withRouter } from "next/router";

const { TabPane } = Tabs;
const { MonthPicker } = DatePicker;

function pageDataWithWalletProductGroupCode(
    data,
    page,
    pagesize,
    walletProductGroupCode
) {
    let ret =
        walletProductGroupCode === "TOTAL"
            ? [...data] // Clone full array
            : walletProductGroupCode
            ? data.filter((v) => v.wallet === walletProductGroupCode)
            : [...data];
    //^^^^^^^^ AppliedHistory API field

    console.log(
        "🚀 ~ file: Promotions.js ~ line 139 ~ pageDataWithWalletProductGroupCode ~ ret",
        ret,
        page,
        pagesize
    );
    ret = pageData(ret, page, pagesize);
    return ret;
}

const RESET_PAEG_NUM = 1;
// Modal加载状态组件
const ModalLoading = (
    <Spin spinning={true} size="large" tip={translate("加载中")} />
);
// 财务管理
const DynamicWallet = dynamic(import("@/Wallet"), {
    loading: () => ModalLoading,
    ssr: true,
});
const Dailydeals = dynamic(import("@/Dailydeals"), {
    loading: () => ModalLoading,
    ssr: false,
});
export async function getStaticProps() {
    return await getStaticPropsFromStrapiSEOSetting("/promotions"); //參數帶本頁的路徑
}
class Main extends React.Component {
    constructor(props) {
        super(props);
        this.RESET_SELECTED_TNC_DETAIL = {};
        const [startDate, endDate] = getStartEndDateByNow();
        this.state = {
            //所需基本資料
            // Promotions: [], //所有Promotion item
            filterdata: this.props.promotions, //依產品類別篩選好的Promotion item
            selectedPromotionDetail: {}, //所選Promotion詳細內容 (為取得最低/最大申請優惠金額)
            currentMoney: {}, // Header > HasLogged Component 传入的金额
            memberInfo: {}, // HasHeader 传入进来的会员相关信息
            cmsBanner: "",
            isLogin: false,
            selectedPromotionItem: null, //所點選Promotion item
            startDate: moment(new Date())
                .subtract(90, "d")
                .startOf("day")
                .utcOffset(8)
                .format("YYYY-MM-DD HH:mm:ss"),
            endDate: moment(new Date())
                .utcOffset(8)
                .format("YYYY-MM-DDTHH:mm:ss"),
            appliedPromotionHistory: [],
            remarks: "",

            //Modal Open 相關
            isManualApplyModalVisible: false,
            isManualAppliedDataVisible: false,
            isManualFullOfApplicantsModal: false, //是否顯示Manual申請已滿Modal
            isPromotionDetailModal: false, //是否顯示優惠詳情Modal
            isDepositWarningModel: false, //是否顯示存款錢包Modal
            isTransferModal: false, // 是否显示轉帳Modal
            isTransferSuccessModal: false, //是否顯示轉帳成功，優惠已申請modal
            isWalletModal: false, //是否顯示存款錢包Modal
            isShowManualResultModal: false, //是否show Manual申請結果
            promotionsApplicationModalVisible: false, //是否顯示優惠申請Modal
            promotionsApplicationModalConfig: {},
            promotionsApplicationModalProps: {},
            promotionErrorModalVisible: false, //是否顯示優惠申請錯誤Modal
            promotionErrorModalConfig: {}, //優惠申請錯誤Modal內容

            //資料顯示狀態判斷
            isManualApplySuccess: false, //是否Manual優惠申請成功結果
            moneyModalLoading: false, // 是否正在Loading计算优惠申请金额可得彩金与流水
            getBonusLoading: false,
            selectedTopTabIndex: "1", //上方Tab選單index (Start from 1, 優惠、我的優惠、返水)
            Tabkey: "0", //左側Tab選單index (Start from 0, 各產品category)
            manualApplyFormSpinning: false,
            pageIndex: 1,
            isRefreshingBalance: false, //是否正在刷新錢包
            isRefreshingPromotion: false, //是否正在更新Bonus優惠狀態 (未申請 => 已申請)
            activeTabKey: "1", // Default active tab key

            // 轉帳相關
            isOneClickTransfer: false, //是否為一鍵轉帳
            modalTabKey: { type: "deposit" }, //錢包動作tab值 (存、提、領)
            fromWalletList: [], // 游戏账户类别（转账优惠申请需要）
            toWalletList: [], // 游戏账户类别（转账优惠申请需要）
            toWalletName: "", // 转账目标账户名称

            //疑似沒用到的
            isDirectModal: false, // 直接申请优惠的窗口
            isDisableImTransfer: "", // Im体育优惠申请一键转入主账户按钮禁用（欧冠）
            ActivePromotionsContent: "",
            searchStr: "", // 搜索优惠值
            promotionDepositValue: 0, // 优惠申请金额
            disabledApplicatioin: false, // 欧冠体育转账申请按钮禁用
            defaultDisabledDirectTransferBtn: true, // 欧冠体育转账默认按钮禁用
            sosAppllication: false, // 救援金申请Loading状态
            isOpenRealyName: false, // 是否打开完善姓名
            realyName: "", // 为了触发完善姓名后的value更新
            manualResultMessage: "", //优惠申请提交结果 message
            toastMessage: "",
            toastType: "",
            remarksMaxLength: 100,
            secondLayerTab: "0",
            pageIndex2: 1,
            waitingToStartLstData: [],
            pageOfWaitingToStartLstData: 1,
            currSecondLayerTab: {},
            aryOngoingLstData: [],
            aryOngoingLstDataFiltered: [],
            OnGoinigBonusTab2selectedCate: "TOTAL",
            pageOfOngoingLstData: 1,
            aryGetableLstData: [],
            pageOfGetableLstData: 1,
            aryBonusAppliedHistory: [],
            aryBonusAppliedHistoryFiltered: [],
            aryBonusAppliedHistoryForDisplay: [],
            AppliedHistoryTab4selectedCate: "TOTAL",
            pageOfBonusAppliedHistory: 1,
            startDate,
            endDate,
            toastMessageInfo: {},
            selectedAssisnedClainBonus: {},
            isAssignedClaimedBonusModal: false,
            lastUpdatedTime: moment()
                .utcOffset(8)
                .format("DD/MM/YYYY HH:mm [GMT+8]"),
            selectedCategory: "TOTAL",
        };

        this.waitingIdOfFirstTabs = 1;
        this.ongoingIdOfFirstTabs = 2;
        this.getableIdOfFirstTabs = 3;
        this.completedIdOfFirstTabs = 4;
        this.firstTabs = [
            { txt: "待开始", id: this.waitingIdOfFirstTabs },
            {
                txt: "进行中",
                id: this.ongoingIdOfFirstTabs,
                targetBonusStatus: [
                    "Pending",
                    "InProgress",
                    "Processing",
                    "RequiredCheck",
                ].map((k) => enumBonusStatus[k].ID),
            },
            {
                txt: "可领取",
                id: this.getableIdOfFirstTabs,
                targetBonusStatus: [enumBonusStatus.ClickToClaim.ID],
            },
            {
                txt: "已完成",
                id: this.completedIdOfFirstTabs,
                targetBonusStatus: [
                    "Cancelled",
                    "ForcedToServed",
                    "Expired",
                    "Complete",
                ].map((k) => enumBonusStatus[k].ID),
                needPagination: true,
            },
        ];

        this.setTlcGameIframeHeightCount = 0;
        this.hasCategoriesdata = false;
        this.Categoriesdata = null;
        this.timer = null; // 输入金额请求间隔时间段
        this.textareaValue = ""; // 自填表单备注信息值（每次都setState会有卡顿现象）
        this.finishRealyNameNextStepInfo = {}; // 完善真实姓名下一步所需（当前优惠详情信息）
        this.promotionIsLogin = false; // 为了避免静态登陆之后重复调用获取优惠的API，本地记录获取状态
        this.setMemberInfo = function () {}; // HasHeader传递过来的方法（设置会员信息）
        this.getBalance = function () {}; // HasHeader传递过来的方法（更新余额）

        this.getBonusDetail = this.getBonusDetail.bind(this); //取得優惠對應之bonus資料
        this.searchPromotion = this.searchPromotion.bind(this); // 搜索优惠
        this.handleTransfer = this.handleTransfer.bind(this); // 优惠申请（转账提交）
        this.SOSPromotionApplications =
            this.SOSPromotionApplications.bind(this); // SOS 电子救援金申请
        this.getPromotionBanner = this.getPromotionBanner.bind(this); // 获取优惠Banner
        this.submitDirectApplication = this.submitDirectApplication.bind(this); // 提交直接申请优惠
        this.getIsManualApplicantFull =
            this.getIsManualApplicantFull.bind(this);
        //---------------------------------------------------
        this.BonusClaim = this.BonusClaim.bind(this);
        this.errorModal = this.errorModal.bind(this);
        this.handleButtonErrorModal = this.handleButtonErrorModal.bind(this);
        this.openOWModalWithProps = this.openOWModalWithProps.bind(this);
        this.showToastAfterSuccess = this.showToastAfterSuccess.bind(this);
        this.showToastAfterFailure = this.showToastAfterFailure.bind(this);
        this.openTnC = this.openTnC.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleAppliedClaimablePromotionCardPageChange =
            this.handleAppliedClaimablePromotionCardPageChange.bind(this);
        this.handlePagination = this.handlePagination.bind(this);
        this.getCampaignAssignedClaimsData =
            this.getCampaignAssignedClaimsData.bind(this);
        this.updatePromoList = this.updatePromoList.bind(this);
    }

    async componentDidMount() {
        if (typeof window !== "undefined") {
            const firstTab = localStorage.getItem("promotionFirstTab");
            const secondTab = localStorage.getItem("promotionSecondTab");
        
            console.log("from localStorage:", firstTab, secondTab);
        
            if (firstTab) {
                this.props.changeTab(firstTab);

              localStorage.removeItem("promotionFirstTab"); // optional: auto-clean
            }
        
            if (secondTab) {
              this.props.setPromotionSecondLayerTab(secondTab);
              localStorage.removeItem("promotionSecondTab"); // optional
            }
          }
        this.getCategories();
        this.props.getAllPromotionRelatedData();
        this.callbackForAppliedHistoryTab(
            this.props.secondLayerTabKey
        );
        this.getPromotionBanner();
        if(this.state.isLogin){
            this.getCampaignAssignedClaimsData();
        }
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ componentDidMount ~ this.props",
            this.props
        );
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl("promotion​​", "Promotion Page​​");
        //由首頁banner點擊跳轉進
        const { id, jumpfrom, type } = Router.router.query;
        if (id && jumpfrom) {
            const item = {
                history: { status: "Apply" },
                promoId: id,
            };
            // 開啟優惠詳細
            this.openPromotionDetailHandler(item, jumpfrom);
        }
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ componentDidMount ~ this.props",
            this.props
        );
        if (
            this.props.isDisableFromSelfExclude === null &&
            this.props.memberInfo?.active
        ) {
            await this.props.fetchMemberSelfExlusionStatus();
        }
        // if((type === "dailyGift" || getQueryVariable("type") === "dailyGift") && this.props.topTabIndex !== "4"){
        //     this.props.changeTab("4");
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        const { secondLayerTabKey, topTabIndex, tabKey } = this.props;
        console.log("upddasdas",prevProps,prevState,this.state.Tabkey)
        console.log("upddasdas111",this.props.topTabIndex)
        console.log("upddasdas222",this.props.secondLayerTabKey)
        if (prevProps?.secondLayerTabKey !== this.props?.secondLayerTabKey ||(prevProps.topTabIndex !== "2" && this.props.topTabIndex === "2")){
            console.log("upddasdas360",this.props.secondLayerTabKey)
            this.callbackForAppliedHistoryTab(
                this.props.secondLayerTabKey
            );
        }
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ componentDidMount ~ this.props",
            this.props
        );
        if (prevState.isLogin !== this.state.isLogin && this.state.isLogin) {
            this.getCampaignAssignedClaimsData();
        }

        if (!prevState.isPromotionDetailModal) {
            this.props.setSelectedBonus(null);
        }
        if (prevProps.promotions !== this.props.promotions) {
            // const { Tabkey, pageIndex } = this.state;
            // console.log("sasadsad", Tabkey, pageIndex);
            // this.setState({ filterdata: this.props.promotions }, () => {
            //     if (this._keepSameTabKeyAndPageIndex) {
            //         this.callback(Tabkey, pageIndex);
            //         this._keepSameTabKeyAndPageIndex = false;
            //     }
            // });
            this.setState({ filterdata: this.props.promotions }, () => {
                this.callback(this.state.Tabkey, this.state.pageIndex);
            });
            let bonusDataArr = this.props.promotions.filter(
                (item) => item.bonusData
            );
            console.log(
                "🚀 ~ Main ~ componentDidMount ~ filterdata ~ bonusData:",
                bonusDataArr
            );

            if (!this.state.selectedPromotionItem) return;

            const newSelectedPromotionItem = this.props.promotions.find(
                (item) =>
                    item.promoId === this.state.selectedPromotionItem.promoId
            );
            console.log(
                "promotion update!!",
                "\n",
                prevProps.promotions,
                "\n",
                this.props.promotions,
                "\n",
                "newSelectedPromotionItem",
                newSelectedPromotionItem
            );

            this.setState({
                selectedPromotionItem: newSelectedPromotionItem,
                isRefreshingPromotion: false,
            });
        }

        if (
            prevState.currentMoney.balanceList !==
            this.state.currentMoney.balanceList
        ) {
            const mainWallet = this.state.currentMoney.balanceList.find(
                (account) => account.name === "MAIN"
            );
            if (
                mainWallet.balance >=
                parseFloat(this.state.selectedPromotionDetail.bonusMinAmount)
            ) {
                this.setState({ isOneClickTransfer: false });
            } else {
                this.setState({ isOneClickTransfer: true });
            }
        }
        if (
            prevProps.itemPromotionDetail !== this.props.itemPromotionDetail &&
            checksObjectHasValue(this.props.itemPromotionDetail)
        ) {
            if (
                Object.prototype.hasOwnProperty.call(
                    this.props.itemPromotionDetail,
                    "promoId"
                )
            ) {
                this.openPromotionDetailHandler(this.props.itemPromotionDetail);
            }
        }
        //在存款成功頁面，點擊"返回優惠頁"按鈕 >> 關閉詳情彈窗、刷新 Promotions List
        if (
            prevProps.backPromotionPage !== this.props.backPromotionPage &&
            this.props.backPromotionPage
        ) {
            this.props.setBackPromotionPage(false);
            this.setState({
                isRefreshingPromotion: true,
                isPromotionDetailModal: false,
                selectedPromotionDetail: [],
                isManualAppliedDataVisible: false,
                isTransferModal: false,
            });
            this.props.setPromotions();
        }
        if (
            prevState.activeTabKey !== this.state.activeTabKey &&
            this.state.activeTabKey === "2"
        ) {
            piwikBonus.runUrlBonus();
        }
    }

    componentWillUnmount() {
        this.props.changeTab("1");
        this.props.setItemPromotionDetail({});
        clearTimeout(this.timer);
        this.setState = () => false;
    }

    _isActiveWaitingOfFirstTab(curFirstTab) {
        return (
            !curFirstTab ||
            !curFirstTab.id ||
            curFirstTab.id === this.waitingIdOfFirstTabs
        );
    }
    _isActiveOngoingOfFirstTab(curFirstTab) {
        return curFirstTab?.id === this.ongoingIdOfFirstTabs;
    }
    _isActiveGetableOfFirstTab(curFirstTab) {
        return curFirstTab?.id === this.getableIdOfFirstTabs;
    }
    _isActiveCompletedOfFirstTab(curFirstTab) {
        return curFirstTab?.id === this.completedIdOfFirstTabs;
    }

    getStateKeyByCurFirstTab(curFirstTab) {
        let stateKey,
            pageStateKey,
            filterDataKey,
            paginatedDataKey,
            selectedCateKey,
            paginationForDisplayDataKey;
        if (this._isActiveOngoingOfFirstTab(curFirstTab)) {
            stateKey = "aryOngoingLstData";
            pageStateKey = "pageOfOngoingLstData";
            filterDataKey = "aryOngoingLstDataFiltered";
            selectedCateKey = "OnGoinigBonusTab2selectedCate";
            paginationForDisplayDataKey = "aryOngoingLstDataForDisplay";
        } else if (this._isActiveGetableOfFirstTab(curFirstTab)) {
            stateKey = "aryGetableLstData";
            pageStateKey = "pageOfGetableLstData";
            filterDataKey = "aryGetableLstDataFiltered";
            paginationForDisplayDataKey = "aryGetableLstDataForDisplay";
        } else if (this._isActiveCompletedOfFirstTab(curFirstTab)) {
            stateKey = "aryBonusAppliedHistory";
            pageStateKey = "pageOfBonusAppliedHistory";
            filterDataKey = "aryBonusAppliedHistoryFiltered";
            paginatedDataKey = "paginatedBonusAppliedHistory";
            selectedCateKey = "AppliedHistoryTab4selectedCate";
            paginationForDisplayDataKey = "aryBonusAppliedHistoryForDisplay";
        }
        return [
            stateKey,
            pageStateKey,
            filterDataKey,
            paginatedDataKey,
            selectedCateKey,
            paginationForDisplayDataKey,
        ];
    }

    GetBonusHistory(opt) {
        let { currSecondLayerTab } = this.state;
        if (this._isActiveWaitingOfFirstTab(currSecondLayerTab)) {
            return;
        }
        opt = opt || {};
        let params = {
            bonusStatusArray: currSecondLayerTab.targetBonusStatus,
        };
        if (opt.year && opt.month) {
            let ym =
                opt.year +
                "-" +
                ((opt.month + "").length < 2 ? "0" + opt.month : opt.month);
            let end = getEndDayOfMonth(opt.year, opt.month);
            let sDate = new Date(ym + "-01 00:00:00")
                .toJSON()
                .replace(".000", "");
            let eDate = new Date(ym + "-" + end + " 23:59:59")
                .toJSON()
                .replace(".000", "");
            params.startDate = sDate;
            params.endDate = eDate;
        } else {
            params.startDate = this.state.startDate;
            params.endDate = this.state.endDate;
        }
        // this.setState({
        // 	isRefreshingHistory: true
        // });
        GetAppliedHistory(params).then((res) => {
            if (res) {
                let [
                    stateKey,
                    pageStateKey,
                    filterDataKey,
                    paginatedDataKey,
                    selectedCateKey,
                    paginationForDisplayDataKey,
                ] = this.getStateKeyByCurFirstTab(currSecondLayerTab);
                if (!stateKey) {
                    alert(
                        "FE: no stateKey because " +
                            JSON.stringify(currSecondLayerTab)
                    );
                    return;
                }
                console.log(
                    "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ GetBonusHistory ~ stateKey",
                    res,
                    stateKey,
                    pageStateKey
                );
                this.setState(
                    {
                        [stateKey]: res,
                        [filterDataKey]: res,
                        [paginationForDisplayDataKey]: res,
                        [pageStateKey]: RESET_PAEG_NUM, // so far, call by DidMount and FirstTabSwitching
                        Tabkey: "0",
                    },
                    () => {
                        if (currSecondLayerTab?.needPagination) {
                            this.handlePagination(currSecondLayerTab);
                        }
                    }
                );
            }
            // this.setState({
            // 	isRefreshingHistory: false
            // });
        });
    }

    async getCampaignAssignedClaimsData() {
        let cache = []; // Array to store all fetched data
        let page = 1;   // Start from page 1
        let pageSize = 50;
        let hasData = true;
        let maxAttempts = 99; // Max number of API calls
        let attempts = 0; // Counter for attempts
    
        while (hasData && attempts < maxAttempts) {
            let res = await getCampaignAssignedClaims({ page, pageSize });
    
            if (res?.isSuccess && res?.result?.isSuccess) {
                let data = res?.result?.data;
    
                if (data.length > 0) {
                    cache.push(...data); // Merge new data into cache
                    page++; // Fetch next page
                    attempts++; // Increase attempt count
                } else {
                    hasData = false; // Stop when API returns an empty array
                }
            } else {
                hasData = false; // Stop loop if API call fails
            }
        }
        cache = cache.filter(item => 
            item?.claimEndDateUtc && moment(item.claimEndDateUtc).isAfter(moment.utc())
        );
        this.setState({
            waitingToStartLstData: [...cache], // Update UI with full cache
        });
    
        console.log("Final cached responses:", cache); // Log the final data cache
        console.log(`Total attempts: ${attempts}`);
    }
    
    

    /**
     * @description: 获取优惠分类
     * @return {*}
     */
    async getCategories() {
        /* 获取全优惠分类 */
        const appliedHistories = await getPromotionCategories();
        if (appliedHistories && appliedHistories.length > 0) {
            const all = {
                PromoCatID: "",
                PromoCatCode: "All",
                resourcesName: translate("全部"),
                promoCatImageUrl: "/vn/img/promotions/icon/icon-all.png",
                parentId: "",
                parentName: "Rebate",
            };

            //篩選出需show在左邊Menu的item
            const categories = appliedHistories.filter(
                (res) => res.parentName === "General"
            );

            this.props.setCategories([all, ...categories]);
            this.Categoriesdata = categories;
            this.hasCategoriesdata && this.props.setPromotions();
            console.log(
                "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ getCategories ~ categories",
                this.props
            );
        }
    }

    handleTabChange = (key) => {
        this.setState({ activeTabKey: key });
    };

    getIsManualApplicantFull(promoID) {
        // if (!this.state.remarks) {
        //     message.error("留言為必填欄位", 3);
        //     this.setState({
        //         manualApplyFormSpinning: false,
        //     });
        //     return;
        // }

        this.setState({
            isRefreshingPromotion: true,
        });
        get(ApiPort.GETManualPromoMaxApplicant + "&promoIds=" + promoID)
            .then((res) => {
                if (res && res.isSuccess) {
                    if (res.result?.isMaxApplicant) {
                        this.setState({ isManualFullOfApplicantsModal: true });
                    } else {
                        this.setState({
                            isManualApplyModalVisible: true,
                        });
                    }
                } else {
                    message.error(
                        "something wrong with checking max applicant of promotion",
                        2
                    );
                }
            })
            .finally(() => {
                this.setState({
                    isRefreshingPromotion: false,
                });
            });
    }

    openOneWalletModal = (configs) => {
        this.setState({
            promotionsApplicationModalVisible: true,
            promotionsApplicationModalConfig: configs?.config,
            promotionsApplicationModalProps: configs?.props,
        });
    };

    setIframeHeight(iframe) {
        if (iframe) {
            var iframeWin =
                iframe.contentWindow || iframe.contentDocument.parentWindow;
            if (iframeWin.document.body) {
                // 内置padding手动设15像素，所以此处额外增加32像素高度
                iframe.style.height =
                    (iframeWin.document.documentElement.offsetHeight ||
                        iframeWin.document.body.offsetHeight) +
                    32 +
                    "px";
            }
        }
    }

    callback(key, targetPage = -1) {
        console.log("qdwqwqdwqddwq", typeof targetPage, key, targetPage);
        Pushgtagdata(
            "Promotion",
            "Promotion Filter​",
            "Promotion_C_Filter​",
            "",
            [
                {
                    customVariableKey: "Promotion_C_Filter_GameCategory​",
                    customVariableValue:
                        this.props?.categories[key]?.PromoCatCode || "All",
                },
            ]
        );
        if (key === null || key === "0") {
            return this.setState({
                filterdata: this.props.promotions,
                Tabkey: "0",
                pageIndex: targetPage !== -1 ? targetPage : 1,
            });
        }
        let filterdata = this.props.promotions.filter((item) =>
            item.category.includes(this.props.categories[key].PromoCatCode)
        );
        this.setState({
            filterdata: filterdata,
            Tabkey: key.toString(),
            pageIndex: targetPage !== -1 ? targetPage : 1,
        });
    }

    updatePromoList = () => {
        console.log(
            "updatePromoListupdatePromoList",
            this.state.Tabkey,
            this.state.pageIndex
        );
        this.props.getAllPromotionRelatedData();
        // this._keepSameTabKeyAndPageIndex = true;
    }; /// used to uupdate promotionlist

    callSecondTabVisitPwik = (key) => {
        switch (key) {
            case "1":
                piwikBonus.run2();
                break;
            case "2":
                piwikBonus.run3();
                break;
            case "3":
                piwikBonus.run4();
                break;
            case "4":
                piwikBonus.run5();
                break;
        }
    };

    callbackForAppliedHistoryTab(key) {
        console.log(
            "🚀 ~ file: Promotions.js:381 ~ Main ~ callbackForAppliedHistoryTab ~ key",
            key
        );
        this.callSecondTabVisitPwik(key);
        let currSecondLayerTab = this.firstTabs.find(
            (item) => item.id === Number(key)
        );
        let [stateKey, pageStateKey, filterDataKey] =
            this.getStateKeyByCurFirstTab(currSecondLayerTab);
        console.log(
            "🚀 ~ file: Promotions.js:381 ~ Main ~ callbackForAppliedHistoryTab ~ currSecondLayerTab",
            currSecondLayerTab,
            stateKey,
            pageStateKey
        );
        if (key === null || key === 0) {
            return this.setState({
                // [stateKey]: this.props.promotions, // need to filter data here
                secondLayerTab: 0,
                [pageStateKey]: key,
                currSecondLayerTab: currSecondLayerTab,
            });
        }

        console.log(
            "🚀 ~ file: Promotions.js:381 ~ Main ~ callbackForAppliedHistoryTab key",
            key
        );

        this.setState(
            {
                secondLayerTab: key,
                [pageStateKey]: 1,
                currSecondLayerTab: currSecondLayerTab,
                // [stateKey]: this.props.promotions,/// need to filter data here
            },
            () => {
                key = key.toString();
                switch (key) {
                    case "1":
                        this.getCampaignAssignedClaimsData();
                        break;
                    case "2":
                    case "3":
                    case "4":
                        this.GetBonusHistory();
                        break;
                }
            }
        );
    }

    getPromotionBanner(loginStatus) {
        //目前说是自己写死,不用api
        // get(
        //     CMSAPIUrl +
        //     "/vi-vn/api/v1/web/webbanners/position/promotion_feature"
        // ).then((res) => {
        //     if (Array.isArray(res) && res.length != 0) {
        //         this.setState({ cmsBanner: res[0].cmsImageUrl });
        //     }
        // });
    }

    getBonusDetail = (wallet, promotionDetailItem, promotionItem) => {
        console.log(
            "🚀 ~ file: Promotions.js:381 ~ Main ~ promotionDetailItem:",
            promotionDetailItem
        );
        if (
            promotionDetailItem.actionType === "NO_ACTION" ||
            promotionDetailItem.promoType === "Manual"
        ) {
            this.props.setSelectedBonus(null);

            this.setState({ WalletBonusProfile: null, getBonusLoading: false });
            return;
        }
        GetWalletBonus(
            wallet,
            (res) => {
                if (res) {
                    const bonus = res.result.find((bonusItem) => {
                        return (
                            String(bonusItem.id) === promotionDetailItem.bonusId
                        );
                    });
                    console.log(
                        "🚀 ~ file: Promotions.js:400 ~ Main ~ bonus ~ bonus:",
                        bonus
                    );
                    // if (!bonus && !promotionItem.history) {
                    //     message.error(
                    //         `api未回傳符合Bonus ID${promotionDetailItem.bonusId}的bonus`
                    //     );
                    // }
                    if (bonus) {
                        this.props.setSelectedBonus(bonus ? bonus : null);
                    }

                    this.setState({
                        WalletBonusProfile: bonus ? bonus : null,
                        getBonusLoading: false,
                    });
                }
            },
            "Transfer"
        );
    };

    imSportPrompt = (value, status, callback) => {
        if (this.imSportPromptShow) return;
        this.imSportPromptShow = true;
        typeof status === "undefined" && (status = true);
        Modal.info({
            title: ``,
            centered: true,
            mask: false,
            content: (
                <div>
                    <img
                        src={`${process.env.BASE_PATH}/img/user/otpVerify/${
                            status ? "icon-success" : "icon-error"
                        }.png`}
                    />
                    <p
                        style={{
                            marginTop: 10,
                            marginBottom: 0,
                            padding: "0 14px",
                        }}
                    >
                        {value}
                    </p>
                </div>
            ),
            className: "showInfoModal opacity _initail",
        });
        // setTimeout(() => {
        //   Modal.destroyAll();
        //   this.imSportPromptShow = false;
        //         typeof callback === 'function' && callback();
        // }, 2000);
    };
    submitDirectApplication(promotionContent) {
        this.setState({ moneyModalLoading: true });
        post(ApiPort.DirectApplyBonus, {
            bonusId: promotionContent.bonusId,
            amount: this.state.promotionDepositValue,
            bonusMode: "Transfer",
            targetWallet: promotionContent.bonusProduct,
            couponText: "",
            isMax: false,
            successBonusId: 0,
            funpodiumPromoId: 0,
            blackBoxValue: getE2BBValue(),
            e2BlackBoxValue: getE2BBValue(),
        }).then((res) => {
            this.setState({ moneyModalLoading: false });
            if (res) {
                if (res.bonusResult && res.bonusResult.message === "Success") {
                    this.imSportPrompt(res.message, true);
                } else {
                    this.setState({ disabledApplicatioin: true });
                    this.imSportPrompt(res.message, false);
                }
            }
        });
    }

    // 轉帳Handler
    handleTransfer(data) {
        console.log("轉帳ing", data);
        const { selectedPromotionItem } = this.state;
        const {
            inputAmount,
            fromWalletDetail,
            fromWalletName,
            toWalletName,
            selectedPromotionDetail,
            isOneClickTransfer,
        } = data;
        const currentSelfContent = this.state.selectedPromotionDetail;
        const totalWalletBalance = this.state.currentMoney.balanceList.find(
            (wallet) => wallet.name === "TotalBal"
        ).balance;

        if (fromWalletDetail.name === "") {
            message.error(translate("请选择转出账户或转入账户！"));
            return;
        }

        const submitData = {
            fromAccount: isOneClickTransfer ? "All" : fromWalletDetail.name,
            toAccount: isOneClickTransfer
                ? fromWalletDetail.name
                : toWalletName,
            amount: isOneClickTransfer ? totalWalletBalance : inputAmount,
            bonusRuleGroupId:
                selectedPromotionItem?.bonusData?.groupID || undefined,
            bonusId: isOneClickTransfer
                ? undefined
                : selectedPromotionItem?.bonusData?.groupID
                ? undefined
                : Number(selectedPromotionDetail.bonusId) || undefined,
            blackBoxValue: getE2BBValue(),
        };

        if (!isOneClickTransfer) {
            if (inputAmount < selectedPromotionDetail.bonusMinAmount) {
                // message.error(`请输入正确的申请金额，低於最低申請金額 ¥ ${selectedPromotionDetail.bonusMinAmount}`)
                message.error(translate("请输入正确的申请金额"));
                return;
            }

            if (inputAmount > fromWalletDetail.balance) {
                message.error(translate("转出账户金额不足！"));

                Modal.confirm({
                    icon: null,
                    title: null,
                    centered: true,
                    closable: false,
                    content: (
                        <React.Fragment>
                            <p className="svg">
                                <svg
                                    viewBox="64 64 896 896"
                                    width="1em"
                                    height="1em"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z" />
                                </svg>
                            </p>
                            <p>
                                {translate("很抱歉，您的")}
                                {fromWalletDetail.localizedName}
                                {translate(
                                    "余额不足，请先进行充值再申请此优惠。"
                                )}
                            </p>
                        </React.Fragment>
                    ),
                    className: "pormotion-confirm",
                    okText: translate("存款"),
                    cancelText: translate("取消"),
                    onOk: () => {
                        global.showDialog({
                            key:
                                'wallet:{"type": "deposit", "targetAccount": "' +
                                currentSelfContent.bonusProduct +
                                '", "bonusId": ' +
                                currentSelfContent.bonusId +
                                ', "money": ' +
                                inputAmount +
                                "}",
                        });
                    },
                });
                return;
            }
        }
        this.setState({ moneyModalLoading: true });
        TransferSubmit(submitData, (res) => {
            this.setState({
                moneyModalLoading: false,
                isDisableImTransfer: isOneClickTransfer ? "curr" : "",
            }); // 欧冠新增：isDisableImTransfer
            if (res) {
                // 0 – failed 失败
                // 1 - success 成功
                // 2 – pending  等待
                if (
                    res.result.status === 1 &&
                    res.result.bonusResult !== "Fail" &&
                    res.result.bonusResult !== ""
                ) {
                    // this.imSportPrompt(res.messages, true, () => {
                    //   // 除了一键转入主账户的按钮外成功后全部关闭本申请窗口
                    //               !isOneClickTransfer && this.setState({ isDirectModal: false, isTransferModal: false });
                    // });
                    GetAllBalance(
                        (data) => {
                            if (!data || !data.isSuccess) {
                                this.getBalance();
                                this.setState({ isTransferModal: false });
                            }
                            this.setState({
                                currentMoney: { balanceList: data.result },
                            });
                        },
                        (status) => {
                            this.setState({ isRefreshingBalance: status });
                        }
                    );
                    // 若為一鍵轉帳成功
                    if (this.state.isOneClickTransfer) {
                        showSmallResultModal(true, translate("转账成功"));
                        setTimeout(() => {
                            Modal.destroyAll();
                        }, 3000);
                        this.setState({
                            isRefreshingPromotion: false,
                        });
                        // 一般轉帳成功
                    } else {
                        this.setState({
                            isTransferModal: false,
                            isTransferSuccessModal: true,
                            isRefreshingPromotion: false,
                        });
                        this.props.updateBonusPromotionHistory(
                            selectedPromotionDetail.promoId
                        );
                    }
                    return;
                } else {
                    if (
                        res.result.status === 1 &&
                        res.result.bonusResult !== "" &&
                        res.result.messages !== ""
                    ) {
                        //"转账成功|申请红利失败"
                        GetAllBalance(
                            (data) => {
                                if (!data || !data.isSuccess) {
                                    this.getBalance();
                                    this.setState({ isTransferModal: false });
                                }
                                this.setState({
                                    currentMoney: { balanceList: data.result },
                                });
                            },
                            (status) => {
                                this.setState({ isRefreshingBalance: status });
                            }
                        );
                        showSmallResultModal(
                            true,
                            translate(res.result.messages)
                        );
                        setTimeout(() => {
                            Modal.destroyAll();
                        }, 3000);
                    } else {
                        message.error(res.result.messages);
                    }
                }
            } else {
                message.error(translate("系统错误，请稍后重试！"));
            }
        });
    }

    searchPromotion() {
        this.setState({
            filterdata: this.props.promotions.filter((item) => {
                return ~item.promoTitle.indexOf(this.state.searchStr)
                    ? item
                    : false;
            }),
        });
    }

    setTlcGameIframeHeight = () => {
        if (document.getElementById("tlc_game_ifame")) {
            //可能已經load完畢，需要檢查document.readyState狀態
            let iframeObj = document.getElementById("tlc_game_ifame");
            let iframeDoc =
                iframeObj.contentDocument || iframeObj.contentWindow
                    ? iframeObj.contentWindow.document
                    : null;
            if (iframeDoc && iframeDoc.readyState == "complete") {
                this.setIframeHeight(iframeObj);
            } else {
                //還沒load完畢 => 等待onload
                iframeObj.onload = () => {
                    this.setIframeHeight(iframeObj);
                };
            }
        } else {
            //最多重試50次(10秒)
            this.setTlcGameIframeHeightCount =
                this.setTlcGameIframeHeightCount + 1;
            if (this.setTlcGameIframeHeightCount <= 50) {
                setTimeout(this.setTlcGameIframeHeight, 200);
            }
        }
    };

    BonusClaim(id) {
        // console.log("BonusClaimMain", item);
        let postData = {
            playerBonusId: id,
        };
        // this.setState({isRefreshingHistory: true})
        post(ApiPort.POSTBonusClaim, postData)
            .then((res) => {
                if (res && res.isSuccess) {
                    if (res.result?.isClaimed) {
                        message.success(res.result?.message);
                        // this.props.setAppliedPromotions(() => {
                        //     this.setState({ isRefreshingHistory: false });
                        // });
                    } else {
                        message.error(res.result?.message);
                        // this.setState({ isRefreshingHistory: false });
                    }
                }
            })
            .catch((error) => {
                console.log("POSTBonusClaim" + error);
                // this.setState({ isRefreshingHistory: false });
            });

        // Pushgtagdata("Promotion_MyPromotion​","Claim Prize​","Promotion_MyPromotion_C_Claim","",
        //     [
        //         {customVariableKey:"Promotion_MyPromotion_C_Claim_PromotionID_PromotioName",
        //         customVariableValue: item.playerBonusId + "_" + item.bonusName
        //     }
        // ]);
    }

    //開啟優惠詳細的handler
    openPromotionDetailHandler(item, jumpfrom) {
        console.log("🚀 ~ Main ~ openPromotionDetailHandler ~ item:", item);
        this.setState({ getBonusLoading: true });
        if (item.promoTitle === "not eligible bonus") {
            message.error(translate("暂无优惠申请资格"));
            return;
        }

        // 獲取Promotion Detail
        let params;
        if (jumpfrom) {
            params = "?id=" + item.promoId + "&jumpfrom=" + jumpfrom;
        } else {
            params = "?id=" + item.promoId;
        }
        // get(ApiPort.PromotionContent + params ).then((res) => {
        //     if (res) {
        //         (res.bonusMinAmount = parseInt(res.bonusMinAmount) || 0),
        //             (res.bonusMaxAmount = parseInt(res.bonusMaxAmount) || 0);
        //         this.props.setSelectedBonus(res);
        //         setTimeout(() => {
        //             if (localStorage.getItem("access_token")) {
        //                 this.getBonusDetail(
        //                     item.bonusData?.account ||
        //                     item.history?.wallet ||
        //                     res.bonusProduct ||
        //                     "",
        //                     res,
        //                     item
        //                 );
        //             } else {
        //                 this.setState({ getBonusLoading: false });
        //             }

        //             this.setState({ selectedPromotionDetail: res }, () => {
        //                 that.setTlcGameIframeHeight();
        //             });
        //         }, 500);
        //     }
        // });

        const paramsDetails = {
            id: item.promoId,
            jumpfrom: jumpfrom,
        };
        //獲取Promotion Detail
        PromotionDetail(paramsDetails).then((res) => {
            if (res) {
                (res.bonusMinAmount = parseInt(res.bonusMinAmount) || 0),
                    (res.bonusMaxAmount = parseInt(res.bonusMaxAmount) || 0);
                this.props.setSelectedBonus(res);
                setTimeout(() => {
                    if (localStorage.getItem("access_token")) {
                        this.getBonusDetail(
                            item.bonusData?.account ||
                                item.history?.wallet ||
                                res.bonusProduct ||
                                "",
                            res,
                            item
                        );
                    } else {
                        this.setState({ getBonusLoading: false });
                    }
                    console.log(
                        "🚀 ~ Main ~ openPromotionDetailHandler ~ res:",
                        res
                    );
                    this.setState({ selectedPromotionDetail: res }, () => {
                        that.setTlcGameIframeHeight();
                    });
                }, 500);
            }
            // this.setState({ getPromotionDetailLoading: false });
            // if (res) {
            //     (res.bonusMinAmount = parseInt(res.bonusMinAmount) || 0),
            //         (res.bonusMaxAmount = parseInt(res.bonusMaxAmount) || 0);
            //     this.setState({
            //         selectedPromotionDetail: res,
            //     });
            // }
        });

        this.setState({
            selectedPromotionItem: item,
            isPromotionDetailModal: true,
        });

        let that = this;
    }

    SOSPromotionApplications(SOSBonusId) {
        this.setState({ sosAppllication: true });
        post(ApiPort.SosBonusVerifications)
            .then((res) => {
                if (res.isSuccess === true) {
                    post(
                        ApiPort.SosBonusApplications +
                            "&SOSBonusId=" +
                            SOSBonusId
                    ).then((res) => {
                        this.setState({ sosAppllication: false });
                        if (res.isSuccess === true) {
                            message.success(res.message);
                            this.getBalance();
                        } else if (res.isSuccess === false) {
                            message.error(res.message);
                        }
                        this.state.sosButton = true;
                    });
                } else if (res.isSuccess === false) {
                    this.setState({ sosAppllication: false });
                    message.error(res.errorMessage);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    /**
     * 充值申请优惠
     * @param {Object} item
     */
    openDepositModal = (item = {}) => {
        console.log("🚀 ~ Main ~ openDepositModal ~ item:", item);
        const reminderModal = Modal.confirm({
            icon: null,
            title: translate("余额不足"),
            centered: true,
            closable: false,
            content: (
                <React.Fragment>
                    {translate(
                        "抱歉，您的余额目前不足以参与本次活动，请“充值”并继续参与。"
                    )}
                </React.Fragment>
            ),
            className:
                "confirm-modal-of-public dont-show-close-button elementTextLeft",
            okText: translate("存款"),
            cancelText: translate("取消"),
            onOk: () => {
                const { selectedPromotionItem } = this.state;
                console.log(
                    "🚀 ~ Main ~ selectedPromotionItem:",
                    selectedPromotionItem
                );
                sessionStorage.setItem(
                    "promoDeposit",
                    JSON.stringify({
                        bonusId: item.bonusId ?? "",
                        bonusRuleGroupId:
                            selectedPromotionItem?.bonusData?.groupID || 0,
                        bonusProduct: item.bonusProduct ?? "",
                        bonusMinAmount: item?.bonusMinAmount ?? "",
                        bonusTitle: item?.promoTitle ?? "",
                    })
                );
                // this.setState({isPromotionDetailModal:false})
                // reminderModal.destroy();
                global.showDialog({
                    key: 'wallet:{"type": "deposit"}',
                });
            },
        });
    };

    // 申請優惠Handler
    Application(item) {
        // 会员未登录
        if (!this.state.isLogin) {
            global.goUserSign(getQueryVariable("isAgent") === "1" ? "2" : "1");
            return;
        }

        // 会员登录信息未返回，不做任何操作
        if (JSON.stringify(this.state.memberInfo) == "{}") {
            return;
        }

        switch (item.promoType) {
            case "Bonus":
                //跳转到外部网站 充值 转账 提款 的类型
                switch (item.actionType) {
                    case "External":
                        window.open(item.actionLinkUrl, `_blank`);
                        break;
                    case "Deposit Page Only":
                    case "DEPOSIT_PAGE_ONLY":
                        this.openDepositModal(item);
                        break;
                    case "Withdrawal":
                        global.showDialog({
                            key: 'wallet:{"type": "withdraw"}',
                        });
                        break;
                    case "SOS":
                        // this.SOSPromotionApplications(item.bonusId);
                        break;
                    default:
                        if (
                            this.state.currentMoney.balanceList &&
                            !this.state.isRefreshingBalance
                        ) {
                            const totalBal =
                                this.state.currentMoney.balanceList.find(
                                    (account) => (account.name = "TotalBal")
                                );

                            const mainWallet =
                                this.state.currentMoney.balanceList.find(
                                    (account) => account.name === "MAIN"
                                );

                            if (
                                totalBal.balance <
                                parseFloat(item.bonusMinAmount)
                            ) {
                                console.log("跳轉至存款頁");
                                // this.setState({ isDepositWarningModel: true });
                                this.openDepositModal(item);
                            } else {
                                const bonusProductResult =
                                    this.state.fromWalletList.find(
                                        (v) => v.key === item.bonusProduct
                                    );

                                if (
                                    mainWallet.balance >=
                                    parseFloat(item.bonusMinAmount)
                                ) {
                                    console.log("跳轉一般轉帳");
                                    this.setState({
                                        isOneClickTransfer: false,
                                        isTransferModal: true,
                                        toWalletName: bonusProductResult
                                            ? bonusProductResult.name
                                            : "",
                                    });
                                } else {
                                    console.log("跳轉一鍵轉帳");
                                    this.setState({
                                        isOneClickTransfer: true,
                                        isTransferModal: true,
                                        toWalletName: bonusProductResult
                                            ? bonusProductResult.name
                                            : "",
                                    });
                                }
                            }
                        } else {
                            console.error("获取钱包api数据失败");
                            message.error(translate("系统错误，请稍后重试！"));
                            return;
                        }
                        break;
                }
                break;
            default:
                break;
        }
    }

    handleButtonErrorModal = (result, isReloadBonus = false, props) => {
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ handleButtonErrorModal ~ result",
            result
        );
        let config = {
            content: (
                <div style={{ paddingTop: "44px" }}>
                    <h3 style={{ textAlign: "center" }}>
                        Yêu cầu đăng ký khuyến mãi đã được tiếp nhận.
                    </h3>
                    <p
                        style={{
                            textAlign: "center",
                            marginBottom: "32px",
                            color: "#666666",
                        }}
                    >
                        {result?.message ||
                            "Đăng ký của bạn đang được xem xét, trạng thái sẽ được cập nhật sớm."}
                    </p>
                </div>
            ),
            buttonLabel: "Đã Hiểu",
            onButtonClick: () => {
                this.setState({
                    promotionErrorModalVisible: false,
                    promotionErrorModalConfig: {},
                });
            },
            showSecondary: false, // Only one button
        };
        if (isReloadBonus) {
            let errRsp = HandleReloadErrorModule(result?.errorCode);
            console.log(
                "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ handleButtonErrorModal ~ errRsp",
                errRsp
            );
            if (errRsp?.showModal) {
                config = errRsp?.config;
                this.openOWModalWithProps(config, props);
                // this.setState({ promotionErrorModalVisible: true, promotionErrorModalConfig: config });
            }
            return;
        }
        if (result?.errorCode) {
            let errRsp = HandleManalPreBonuseErrorModule(result?.errorCode);
            if (errRsp?.showModal) {
                config = errRsp?.config;
                this.setState({
                    promotionErrorModalVisible: true,
                    promotionErrorModalConfig: config,
                });
            } else {
                this.showToastAfterFailure();
            }
        }
    };

    // Function to open the modal with config and props
    openPromotionModal = (config = {}, modalProps = {}) => {
        this.setState({
            promotionsApplicationModalVisible: true,
            promotionsApplicationModalConfig: config,
            promotionsApplicationModalProps: modalProps,
        });
    };

    // Function to close the modal and reset state
    closePromotionModal = () => {
        this.setState({
            promotionsApplicationModalVisible: false,
            promotionsApplicationModalConfig: {},
            promotionsApplicationModalProps: {},
        });
    };

    openTnC = (item) => {
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ openTnC ~ item",
            item
        );
        this.setState({
            isAssignedClaimedBonusModal: true,
            selectedAssisnedClainBonus: item,
        });
    };

    errorModal = () => {
        // 顯示錯誤模態框
        Modal.info({
            title: "",
            centered: true,
            okText: "Đã Hiểu",
            icon: <div />,
            maskClosable: false,
            className: "error-modal-Smartico",
            onOk: () => {},
            content: (
                <>
                    <img
                        src={"/vn/img/icons/icon-warn_yellow.png"}
                        alt="Warning"
                    />
                    <div style={{ fontSize: 14, color: "#222", marginTop: 16 }}>
                        Dịch vụ đang tạm thời bị gián đoạn, vui lòng thử lại
                        sau.
                    </div>
                </>
            ),
        });
    };

    handleAppliedClaimablePromotionCardPageChange = (pageNum, tabInfo) => {
        let [stateKey, pageStateKey, filterDataKey] =
            this.getStateKeyByCurFirstTab(tabInfo);
        let pageSize = 3; // Adjust page size as needed
        console.log(
            "🚀 stateKeyzzzz:",
            pageNum,
            "aryBonusAppliedHistoryFiltered:",
            this.state[filterDataKey]
        );
        this.setState(
            (prevState) => {
                // ✅ 1. **Filter the data first**
                let originalData = prevState[stateKey] || [];

                // console.log(
                //     "🚀 Filtered Category Data:",
                //     originalData,
                //     this.state[stateKey]
                // );

                // ✅ 2. **Reset to page 1 and Paginate on the filtered data**

                return {
                    [pageStateKey]: pageNum, // Store only paginated items
                    // [pageStateKey]: newPageNumber, // Reset pagination
                };
            },
            () => {
                // ✅ **Callback runs after state update**
                console.log("✅ State updated:", this.state);
            }
        );
    };

    handleCategoryChange = (categoryCode, tabInfo) => {
        let [
            stateKey,
            pageStateKey,
            filterDataKey,
            paginatedDataKey,
            selectedCateKey,
            paginationForDisplayDataKey,
        ] = this.getStateKeyByCurFirstTab(tabInfo);
        let pageSize = 3; // Adjust page size as needed

        console.log(
            "🚀 stateKey:",
            stateKey,
            "pageStateKey:",
            pageStateKey,
            "stateData:",
            this.state[stateKey]
        );

        const categoryData = enumWalletProductGroupId?.[categoryCode];
        const piwikCategoryName = categoryData?.piwikName || "";
        console.log("🚀 categoryDataBeforPiwik:", categoryData, categoryCode,this._isActiveOngoingOfFirstTab(tabInfo), tabInfo);
        Pushgtagdata(
            "Bonus",
            this._isActiveOngoingOfFirstTab(tabInfo) ? "Choose Bonus Category" : "Filter Archived Bonus",
            this._isActiveOngoingOfFirstTab(tabInfo)  ? "Bonus_C_FilterCategory" : "Bonus_Archived_C_Category",
            false,
            [
                {
                    customVariableKey: this._isActiveOngoingOfFirstTab(tabInfo) ? "Bonus_C_FilterCategory" : "Bonus_Archived_C_Category",
                    customVariableValue: piwikCategoryName,
                },
            ]
        );
        this.setState(
            (prevState) => {
                // ✅ 1. **Filter the data first**
                let filteredCategoryData =
                    categoryCode === "TOTAL"
                        ? prevState[stateKey] // No filtering if "TOTAL"
                        : prevState[stateKey]?.filter(
                              (item) => item.productGroup === categoryCode
                          ) || [];
                console.log("🚀 filteredCategoryData:", filteredCategoryData);

                return {
                    [selectedCateKey]: categoryCode, // Store selected category
                    [filterDataKey]: filteredCategoryData, // Store filtered data
                    [paginationForDisplayDataKey]: filteredCategoryData,
                };
            },
            () => {
                console.log("✅ State updated:", this.state);
            }
        );
    };

    // Manual Promotion 申請Handler
    PromApplications() {
        this.setState({
            manualApplyFormSpinning: true,
        });
        const { memberInfo } = this.state;
        // if (
        //     !memberInfo.firstName ||
        //     !(memberInfo.isVerifiedPhone && memberInfo.isVerifiedPhone[0]) ||
        //     !(memberInfo.isVerifiedEmail && memberInfo.isVerifiedEmail[0])
        // ) {
        //     message.error(
        //         translate("请完善您的个人资料"),
        //         3,
        //         Router.push("/me/account-info")
        //     );
        //     this.props.changeUserCenterTabKey("userinfo");
        //     return;
        // }

        // if (!this.state.remarks) {
        //     message.error(translate("留言为必填栏位"));
        //     this.setState({
        //         manualApplyFormSpinning: false,
        //     });
        //     return;
        // }

        let Data = {
            promoType: "ManualPromo",
            promoId: Number(this.state.selectedPromotionDetail.promoId),
            applySite: 14,
            contactNo:
                memberInfo.isVerifiedPhone && memberInfo.isVerifiedPhone[0],
            remark: this.state.remarks,
            email: memberInfo.isVerifiedEmail && memberInfo.isVerifiedEmail[0],
        };
        post(ApiPort.POSTPromotionApplications, Data)
            .then((data) => {
                if (data?.result?.isPromoApplied) {
                    this.setState({
                        isManualApplySuccess: true,
                        isShowManualResultModal: true,
                    });
                } else {
                    this.setState({
                        isManualApplySuccess: false,
                        isShowManualResultModal: true,
                        manualResultMessage:
                            getDisplayPublicError(data) ||
                            translate("系统错误，请联系在线支持！"),
                    });
                }
                this.setState({
                    manualApplyFormSpinning: false,
                    remarks: "",
                });
            })
            .catch((e) => {
                console.error(e);
                this.setState({
                    isManualApplySuccess: false,
                    isShowManualResultModal: true,
                    manualApplyFormSpinning: false,
                    manualResultMessage:
                        getDisplayPublicError(e) ||
                        translate("系统错误，请联系在线支持！"),
                });
            });
    }

    openOWModalWithProps(config, params) {
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ promotionsApplicationModalVisible ~ selectedPromotionDetail",
            this.state.promotionsApplicationModalVisible,
            config
        );
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ promotionsApplicationModalVisible ~ params",
            params
        );
        params = {
            showToastAfterSuccess: this.showToastAfterSuccess,
            showToastAfterFailure: this.showToastAfterFailure,
            ...params,
        };
        this.setState({
            // isPromotionDetailModal: false,
            promotionsApplicationModalProps: params,
            promotionsApplicationModalConfig: config,
            promotionsApplicationModalVisible: true,
        });
    }

    handleTextareaChange(e) {
        const value = e.target.value;
        const maxLength = 100;

        // Regex to allow Latin characters, numbers, basic punctuation, and Vietnamese characters
        const regex =
            /^[a-zA-Z0-9 .,!?ăâêôơưđĂÂÊÔƠƯĐáàảãạắằẳẵặấầẩẫậéèẻẽẹếềểễệíìỉĩịóòỏõọốồổỗộớờởỡợúùủũụứừửữựýỳỷỹỵÁÀẢÃẠẮẰẲẴẶẤẦẨẪẬÉÈẺẼẸẾỀỂỄỆÍÌỈĨỊÓÒỎÕỌỐỒỔỖỘỚỜỞỠỢÚÙỦŨỤỨỪỬỮỰÝỲỶỸỴ]*$/;

        // Filter out invalid characters
        let filteredValue = Array.from(value)
            .filter((char) => regex.test(char))
            .join("");

        // Limit the input to 100 characters
        let truncatedValue = filteredValue.slice(0, maxLength);

        this.setState({ remarks: truncatedValue });
    }

    handlePagination(tabInfo, e = 1) {
        let [
            stateKey,
            pageStateKey,
            filterDataKey,
            paginatedDataKey,
            selectedCateKey,
            paginationForDisplayDataKey,
        ] = this.getStateKeyByCurFirstTab(tabInfo);
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ render ~ selectedCateKey",
            tabInfo,
            stateKey
        );
        let walletProductGroupCode = this.state[selectedCateKey];
        let paginatedData = pageDataWithWalletProductGroupCode(
            this.state[stateKey],
            e,
            9,
            walletProductGroupCode
        );
        console.log(
            "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ render ~ paginatedData",
            paginatedData,
            this.state[stateKey],
            e,
            9,
            walletProductGroupCode
        );
        this.setState({
            [paginationForDisplayDataKey]: paginatedData,
            [pageStateKey]: e,
            Tabkey: "0",
        });
    }

    showToastAfterSuccess(txt) {
        console.log("showToastAfterSuccesscalled");
        showSuccessToast(txt);
        this.setState(
            {
                selectedPromotionItem: {},
                isPromotionDetailModal: false,
            },
            () => {
                this.updatePromoList();
            }
        );
    }

    showToastAfterFailure() {
        // this.setState({
        //     selectedPromotionItem: {},
        //     isPromotionDetailModal: false,
        // });
        showErrorToast();
    }

    render() {
        const {
            filterdata,
            manualApplyFormSpinning,
            Tabkey,
            appliedPromotionHistory,
            selectedPromotionItem,
            selectedPromotionDetail,
            isManualApplyModalVisible,
            isManualAppliedDataVisible,
            isLogin,
            currentMoney,
            moneyModalLoading,
            fromWalletList,
            toWalletName,
            isTransferModal,
            WalletBonusProfile,
            isOneClickTransfer,
            isPromotionDetailModal,
            isTransferSuccessModal,
            selectedTopTabIndex,
            pageIndex,
            isManualFullOfApplicantsModal,
            isRefreshingBalance,
            isRefreshingPromotion,
            getBonusLoading,
            manualResultMessage,
            waitingToStartLstData,
            aryOngoingLstData,
            pageOfOngoingLstData,
            aryOngoingLstDataFiltered,
            aryGetableLstData,
            pageOfGetableLstData,
            aryBonusAppliedHistory,
            aryBonusAppliedHistoryFiltered,
            aryBonusAppliedHistoryForDisplay,
            pageOfBonusAppliedHistory,
        } = this.state;
        const appliedPromotion = appliedPromotionHistory.find((item) => {
            return (
                item?.promoId === selectedPromotionItem?.promoId ||
                String(item?.promotionId) === selectedPromotionItem?.promoId
            );
        });
        const imgsrc = `${
            process.env.BASE_PATH
        }/img/promotions/Banner-for-promotion.${
            isWebPSupported() ? "webp" : "jpg"
        }`;
        // console.log(
        //     "🚀 ~ file: Promotions.js:1155 ~ Main ~ render ~ this.props.categories:",
        //     isRefreshingPromotion ,
        //     !selectedPromotionDetail.body ,
        //     getBonusLoading
        // )
        // console.log("filterdata",filterdata)
        console.log("waitingToStartLstData", waitingToStartLstData);
        return (
            <Layout
                title=""
                Keywords=""
                description=""
                status={1}
                setUserCenterMoney={(v) => {
                    this.setState({ currentMoney: v });

                    // 设置会员信息，顺便更新登陆之后的Banner
                    this.getPromotionBanner(true);

                    !this.promotionIsLogin && this.props.setPromotions();
                }}
                getPromotionList={() => {
                    this.props.setPromotions();
                }}
                setUserCenterMemberInfo={(v, setMemberInfo, getBalance) => {
                    // 转账优惠申请（转账类型）
                    GetWalletList((res) => {
                        this.setState({
                            fromWalletList: res.result.fromWallet,
                            toWalletList: res.result.toWallet,
                        });
                    });

                    this.setState({ memberInfo: v }); // HasHeader传入进的会员信息
                    this.setMemberInfo = setMemberInfo; // 设置HasHeader会员信息以及更新全部信息
                    this.getBalance = getBalance; // HasHeader传入进的获取余额方法
                }}
                setLoginStatus={(v) => {
                    this.setState({ isLogin: v });
                }}
                seoData={this.props.seoData}
            >
                <div className="promotions-banner">
                    <img src={imgsrc} alt={this.props.topTabIndex + "banner"} />
                </div>
                {/* <Button onClick={() => this.updatePromoList()}>testtt</Button> */}
                <div className="common-distance-wrap promotions-content">
                    <div className="common-distance promotion-tabs">
                        {(!this.props.promotions?.length ||
                            !this.props.categories?.length) && (
                            <ul className="loading_card_list">
                                {[...Array(9)].map((item, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="box">
                                                <div className="box_title" />
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                        {this.props.promotions != "" &&
                            this.props.categories.length != 0 && (
                                <React.Fragment>
                                    {/* <Input
									className="promotion-search"
									addonAfter={<div onClick={this.searchPromotion}>搜索</div>}
									value={this.state.searchStr}
									onChange={({ target: { value: v } }) => {
										this.setState({ searchStr: v });
									}}
									onPressEnter={this.searchPromotion}
									size="large"
									placeholder="更多"
									autoComplete="off"
								/> */}
                                    <Tabs
                                        className="border-tabs"
                                        activeKey={this.props.topTabIndex}
                                        onChange={(tabKey) => {
                                            this.handleTabChange(tabKey);
                                            if (
                                                tabKey !==
                                                this.props.topTabIndex
                                            ) {
                                                if (
                                                    tabKey == "2" ||
                                                    tabKey == "3"
                                                ) {
                                                    if (!this.state.isLogin) {
                                                        global.goUserSign(
                                                            getQueryVariable(
                                                                "isAgent"
                                                            ) === "1"
                                                                ? "2"
                                                                : "1"
                                                        );
                                                    } else {
                                                        this.props.changeTab(
                                                            `${tabKey}`
                                                        );
                                                    }
                                                } else {
                                                    this.props.changeTab(
                                                        `${tabKey}`
                                                    );
                                                }
                                                this.props.setPromotionSecondLayerTab("2")
                                                tabKey == "1" &&
                                                    Pushgtagdata(
                                                        "Promotion",
                                                        "Switch to Promotion​​​",
                                                        "Promotion_Tab_C_Promotion"
                                                    );
                                                tabKey == "2" &&
                                                    Pushgtagdata(
                                                        "Promotion",
                                                        "Switch to My Promotion​​​​",
                                                        "Promotion_Tab_C_MyPromotion​"
                                                    );
                                                tabKey == "3" &&
                                                    Pushgtagdata(
                                                        "Promotion",
                                                        "Switch to Rebate​​​​​​",
                                                        "Promotion_Tab_C_TurnoverRebate​"
                                                    );
                                                tabKey == "4" &&
                                                    Pushgtagdata(
                                                        "Promotion",
                                                        "Switch to Daily Deal",
                                                        "Promotion_Tab_C_DailyDeal​"
                                                    );
                                            }
                                        }}
                                    >
                                        <TabPane
                                            className="upper-tab"
                                            tab={<div>{translate("优惠")}</div>}
                                            key="1"
                                        >
                                            <Tabs
                                                tabPosition={"left"}
                                                className="tlc-promotions-sidebar"
                                                activeKey={Tabkey}
                                                onChange={(e) =>
                                                    this.callback(e)
                                                }
                                            >
                                                {this.props.categories.map(
                                                    (item, index) => (
                                                        <TabPane
                                                            tab={
                                                                <span className="icon-list">
                                                                    <img
                                                                        className={`icon-image ${
                                                                            Tabkey ===
                                                                                index.toString() &&
                                                                            "icon-image-active"
                                                                        }`}
                                                                        src={
                                                                            item.promoCatImageUrl
                                                                        }
                                                                        style={{
                                                                            filter: "greyscale(1)",
                                                                        }}
                                                                    />
                                                                    {
                                                                        item.resourcesName
                                                                    }
                                                                </span>
                                                            }
                                                            key={index}
                                                        >
                                                            {/* 每項item (右半邊) */}
                                                            <div className="promotion-list-box">
                                                                <Spin
                                                                    spinning={
                                                                        isRefreshingPromotion
                                                                    }
                                                                    tip={translate(
                                                                        "加载中"
                                                                    )}
                                                                >
                                                                    <ul className="Pms_data_list">
                                                                        {filterdata.length ? (
                                                                            filterdata
                                                                                .slice(
                                                                                    (pageIndex -
                                                                                        1) *
                                                                                        9,
                                                                                    pageIndex *
                                                                                        9
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        item,
                                                                                        key
                                                                                    ) => {
                                                                                        return (
                                                                                            <li
                                                                                                key={
                                                                                                    "pms-data-" +
                                                                                                    key
                                                                                                }
                                                                                                onClick={() => {
                                                                                                    this.openPromotionDetailHandler(
                                                                                                        item
                                                                                                    );
                                                                                                    piwikPromotion.runUrlPromo(
                                                                                                        item?.promoTitle
                                                                                                    );
                                                                                                    Pushgtagdata(
                                                                                                        "Promotion",
                                                                                                        "View Promo​",
                                                                                                        "Promotion_V_Promotion​",
                                                                                                        "",
                                                                                                        [
                                                                                                            {
                                                                                                                customVariableKey: `Promotion_V_${
                                                                                                                    item
                                                                                                                        ?.category[0] ||
                                                                                                                    ""
                                                                                                                }_PromoName_PrmoID​​`,
                                                                                                                customVariableValue:
                                                                                                                    item.promoTitle +
                                                                                                                    "_" +
                                                                                                                    item.promoId,
                                                                                                            },
                                                                                                        ]
                                                                                                    );
                                                                                                }}
                                                                                                className="promotion-item-box"
                                                                                            >
                                                                                                <div className="content-box">
                                                                                                    <div className="item-list">
                                                                                                        <ImageWithFallback
                                                                                                            src={
                                                                                                                item.promoImage
                                                                                                            }
                                                                                                            width={
                                                                                                                282
                                                                                                            }
                                                                                                            height={
                                                                                                                108
                                                                                                            }
                                                                                                            alt={
                                                                                                                item.promoTitle
                                                                                                            }
                                                                                                            fallbackSrc={`${process.env.BASE_PATH}/img/logo/logo.svg`}
                                                                                                        />

                                                                                                        <div className="text-box">
                                                                                                            <div className="titleContainer">
                                                                                                                <p className="title">
                                                                                                                    {
                                                                                                                        item.promoTitle
                                                                                                                    }
                                                                                                                </p>
                                                                                                                <div>
                                                                                                                    <OneWalletPromotionPageButton
                                                                                                                        data={
                                                                                                                            item
                                                                                                                        }
                                                                                                                        withinTnCmodal={
                                                                                                                            false
                                                                                                                        }
                                                                                                                        showToastAfterSuccess={
                                                                                                                            this
                                                                                                                                .showToastAfterSuccess
                                                                                                                        }
                                                                                                                        showToastAfterFailure={
                                                                                                                            this
                                                                                                                                .showToastAfterFailure
                                                                                                                        }
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div
                                                                                                                className="period"
                                                                                                                onClick={(
                                                                                                                    e
                                                                                                                ) =>
                                                                                                                    e.target.setAttribute(
                                                                                                                        "title",
                                                                                                                        JSON.stringify(
                                                                                                                            item
                                                                                                                        )
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                <span>
                                                                                                                    <img
                                                                                                                        src={`${process.env.BASE_PATH}/img/promotions/time.svg`}
                                                                                                                    />
                                                                                                                </span>
                                                                                                                <p>{`${moment(
                                                                                                                    item.startDate
                                                                                                                ).format(
                                                                                                                    "DD-MM-YYYY HH:mm:ss"
                                                                                                                )}-${moment(
                                                                                                                    item.endDate
                                                                                                                ).format(
                                                                                                                    "DD-MM-YYYY HH:mm:ss"
                                                                                                                )}`}</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </li>
                                                                                        );
                                                                                    }
                                                                                )
                                                                        ) : (
                                                                            <Empty
                                                                                image={
                                                                                    "/vn/img/promotions/non-promotion.png"
                                                                                }
                                                                                description={
                                                                                    <p>
                                                                                        {translate(
                                                                                            "目前没有促销活动。"
                                                                                        )}
                                                                                    </p>
                                                                                }
                                                                            />
                                                                        )}
                                                                    </ul>
                                                                </Spin>
                                                                {filterdata.length >
                                                                    9 && (
                                                                    <Pagination
                                                                        className="general-pagination custom-pagination"
                                                                        style={{
                                                                            textAlign: "center", // Centers pagination
                                                                        }}
                                                                        defaultCurrent={
                                                                            this
                                                                                .state
                                                                                .pageIndex
                                                                        }
                                                                        pageSize={
                                                                            9
                                                                        }
                                                                        current={
                                                                            this
                                                                                .state
                                                                                .pageIndex
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.setState(
                                                                                {
                                                                                    pageIndex:
                                                                                        e,
                                                                                }
                                                                            );
                                                                        }}
                                                                        total={
                                                                            filterdata.length
                                                                        }
                                                                        itemRender={(
                                                                            current,
                                                                            type,
                                                                            originalElement
                                                                        ) => {
                                                                            if (type === "prev") {
                                                                                return (
                                                                                    <div>
                                                                                        <span>
                                                                                            <img
                                                                                                style={{
                                                                                                    width: "12px",
                                                                                                    height: "12px",
                                                                                                    filter: this.state.pageIndex !== 1 ? "invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(100%)" : "invert(86%) sepia(7%) saturate(162%) hue-rotate(192deg) brightness(95%) contrast(90%)",
                                                                                                }}
                                                                                                src="/vn/img/1wallet/newbie/paginationLeftArrow.svg"
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            if (type === "next") {
                                                                                return (
                                                                                    <div>
                                                                                        <span>
                                                                                            <img
                                                                                                style={{
                                                                                                    width: "12px",
                                                                                                    height: "12px",
                                                                                                    filter: "invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(100%)",
                                                                                                }}
                                                                                                src="/vn/img/1wallet/newbie/paginationRightArrow.svg"
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return originalElement;
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </TabPane>
                                                    )
                                                )}
                                            </Tabs>
                                        </TabPane>
                                        <TabPane
                                            tab={
                                                <div>
                                                    {translate("已申请优惠")}
                                                </div>
                                            }
                                            key="2"
                                            className="one-wallet-2025-applieHistory-second-tab"
                                        >
                                            <div
                                                className="one-wallet-2025-applieHistory-second-tab-wrapper"
                                                style={{
                                                    width: "100%",
                                                }}
                                            >
                                                <Tabs
                                                    defaultActiveKey={
                                                        this.props
                                                            ?.secondLayerTabKey !==
                                                        null
                                                            ? this.props
                                                                  ?.secondLayerTabKey
                                                            : "1"
                                                    }
                                                    onChange={(key) => {
                                                        // this.callbackForAppliedHistoryTab(
                                                        //     key
                                                        // );
                                                        this.props?.setPromotionSecondLayerTab(key)
                                                    }}
                                                    style={{
                                                        borderBottom: "none",
                                                    }}
                                                    className="one-wallet-2025-applieHistory-second-tab"
                                                    activeKey={ this.props
                                                        ?.secondLayerTabKey !==
                                                    null
                                                        ? this.props
                                                              ?.secondLayerTabKey
                                                        : "1"}
                                                >
                                                    <TabPane
                                                        tab={
                                                            <span
                                                                style={{
                                                                        fontSize:
                                                                        "14px",
                                                                }}
                                                            >
                                                                Sắp bắt đầu
                                                            </span>
                                                        }
                                                        key="1"
                                                    >
                                                        {waitingToStartLstData.length >
                                                        0 ? (
                                                            <div>
                                                                <div
                                                                    style={{
                                                                        color: "#A1A1A1",
                                                                        fontSize:
                                                                            "12px",
                                                                        fontWeight:
                                                                            "400",
                                                                        marginBottom:
                                                                            "20px",
                                                                    }}
                                                                >
                                                                    Thời gian
                                                                    cập nhật
                                                                    cuối cùng:
                                                                    <span>
                                                                        {
                                                                            this
                                                                                .state
                                                                                .lastUpdatedTime
                                                                        }
                                                                    </span>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            "grid",
                                                                        gridTemplateColumns:
                                                                            "repeat(3, 1fr)", // Use camelCase for property names
                                                                        gap: "16px", // Adds space between grid items
                                                                        width: "100%", // Correct usage for width
                                                                        minHeight: "130px"
                                                                    }}
                                                                >
                                                                    {waitingToStartLstData.map(
                                                                        (
                                                                            item,
                                                                            index
                                                                        ) => {
                                                                            console.log(
                                                                                "🚀 ~ file: Promotions.js ~ line 1530 ~ Main ~ render ~ item",
                                                                                item
                                                                            );

                                                                            return (
                                                                                <AssinedClaimedBonusCard
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    Config={
                                                                                        item
                                                                                    }
                                                                                    OpenModal={
                                                                                        this
                                                                                            .openOneWalletModal
                                                                                    }
                                                                                    openTnC={
                                                                                        this
                                                                                            .openTnC
                                                                                    }
                                                                                />
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        marginTop:
                                                                            "20px",
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            color: "#222222",
                                                                            fontWeight:
                                                                                "600",
                                                                            fontSize:
                                                                                "12px",
                                                                        }}
                                                                    >
                                                                        Lời nhắc
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            color: "#666666",
                                                                            fontSize:
                                                                                "12px",
                                                                            fontWeight:
                                                                                "400",
                                                                        }}
                                                                    >
                                                                        Vui lòng
                                                                        chọn
                                                                        "Nhận
                                                                        khuyến
                                                                        mãi" để
                                                                        tham gia
                                                                        trước
                                                                        "Thời
                                                                        gian kết
                                                                        thúc
                                                                        khuyến
                                                                        mãi";
                                                                        nếu
                                                                        không,
                                                                        Khuyến
                                                                        mãi sẽ
                                                                        không
                                                                        còn hiệu
                                                                        lực, và
                                                                        sẽ bị
                                                                        xóa khỏi
                                                                        danh
                                                                        sách.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <Col span={24}>
                                                                <Empty
                                                                    image={
                                                                        "/vn/img/icon/img-no-record.svg"
                                                                    }
                                                                    className="big-empty-box"
                                                                    description={translate(
                                                                        "Không có thưởng nào"
                                                                    )}
                                                                />
                                                            </Col>
                                                        )}
                                                    </TabPane>
                                                    <TabPane
                                                        tab={
                                                            <span
                                                                style={{
                                                                        fontSize:
                                                                        "14px",
                                                                }}
                                                            >
                                                                Đang tiếp diễn
                                                            </span>
                                                        }
                                                        key="2"
                                                    >
                                                        <div className="one-wallet-2025-applieHistory-second-tab-wrapper">
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    flexWrap:
                                                                        "wrap",
                                                                    gap: "12px",
                                                                    alignItems:
                                                                        "flex-start",
                                                                    width: "100%",
                                                                    marginBottom:
                                                                        "20px",
                                                                }}
                                                            >
                                                                {this.props?.balanceInfo?.balances.map(
                                                                    (
                                                                        category,
                                                                        i
                                                                    ) => (
                                                                        <button
                                                                            key={
                                                                                i
                                                                            }
                                                                            className={`category-tab ${
                                                                                category?.walletProductGroupCode ===
                                                                                this
                                                                                    .state
                                                                                    .OnGoinigBonusTab2selectedCate
                                                                                    ? "active"
                                                                                    : ""
                                                                            }`}
                                                                            onClick={() => {
                                                                                let tabInfo =
                                                                                    this.firstTabs?.find(
                                                                                        (
                                                                                            tab
                                                                                        ) =>
                                                                                            tab.id ===
                                                                                            this
                                                                                                .ongoingIdOfFirstTabs
                                                                                    );
                                                                                console.log(
                                                                                    "🚀 Clicked tabInfo:",
                                                                                    tabInfo
                                                                                );
                                                                                this.handleCategoryChange(
                                                                                    category?.walletProductGroupCode,
                                                                                    tabInfo
                                                                                );
                                                                            }}
                                                                        >
                                                                            {category?.walletProductGroupId === 1 ? "Tất Cả" : category?.walletProductGroupName}
                                                                        </button>
                                                                    )
                                                                )}
                                                            </div>
                                                            {/* Footer Note & Filtered Promotions List */}
                                                            {aryOngoingLstDataFiltered.length >
                                                            0 ? (
                                                                <>
                                                                    <div
                                                                        style={{
                                                                            color: "#A1A1A1",
                                                                            fontSize:
                                                                                "12px",
                                                                            fontWeight:
                                                                                "400",
                                                                            marginBottom:
                                                                                "20px",
                                                                        }}
                                                                    >
                                                                        Thời
                                                                        gian cập
                                                                        nhật
                                                                        cuối
                                                                        cùng:{" "}
                                                                        <span>
                                                                            {
                                                                                this
                                                                                    .state
                                                                                    .lastUpdatedTime
                                                                            }
                                                                        </span>
                                                                    </div>

                                                                    {/* Promotions Grid */}
                                                                    <div
                                                                        style={{
                                                                            display:
                                                                                "grid",
                                                                            gridTemplateColumns:
                                                                                "repeat(3, 1fr)",
                                                                            gap: "16px",
                                                                            marginTop:
                                                                                "16px",
                                                                        }}
                                                                    >
                                                                        {aryOngoingLstDataFiltered.map((card, index) => {
                                                                            const commonProps = {
                                                                                key: index,
                                                                                item: card,
                                                                                openPromotionModal: this.openPromotionModal,
                                                                                closePromotionModal: this.closePromotionModal,
                                                                                showToastAfterSuccess: this.showToastAfterSuccess,
                                                                                showToastAfterFailure: this.showToastAfterFailure,
                                                                                updateAppliedHistory: () => {
                                                                                    this.callbackForAppliedHistoryTab(this.props.secondLayerTabKey);
                                                                                },
                                                                            };

                                                                            const componentsMap = {
                                                                                RewardsPoint: AppliedInProgressPromotionCard.RewardPoint,
                                                                                FreeSpin: AppliedInProgressPromotionCard.FreeSpin,
                                                                            };

                                                                            const Component =
                                                                                componentsMap[card?.bonusGivenType] || AppliedInProgressPromotionCard;

                                                                            return <Component {...commonProps} />;
                                                                        })}
                                                                    </div>

                                                                    {/* Reminder Section */}
                                                                    <div
                                                                        style={{
                                                                            fontWeight:
                                                                                "bold",
                                                                            color: "#222222",
                                                                            marginTop:
                                                                                "20px",
                                                                        }}
                                                                    >
                                                                        Lời nhắc
                                                                    </div>
                                                                    <div>
                                                                        <div
                                                                            style={{
                                                                                color: "#666666",
                                                                            }}
                                                                        >
                                                                            1.
                                                                            Sau
                                                                            khi
                                                                            hoàn
                                                                            thành
                                                                            điều
                                                                            kiện{" "}
                                                                            <span
                                                                                style={{
                                                                                    fontWeight:
                                                                                        "bold",
                                                                                    color: "#222222",
                                                                                }}
                                                                            >
                                                                                thưởng
                                                                                có
                                                                                sẵn
                                                                            </span>
                                                                            ,
                                                                            vui
                                                                            lòng
                                                                            nhấp
                                                                            vào
                                                                            [Thưởng
                                                                            có
                                                                            sẵn]
                                                                            để
                                                                            nhận
                                                                            thưởng.
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                color: "#666666",
                                                                            }}
                                                                        >
                                                                            2.
                                                                            Nếu
                                                                            không
                                                                            hoàn
                                                                            thành
                                                                            các
                                                                            điều
                                                                            kiện
                                                                            thưởng
                                                                            trong
                                                                            thời
                                                                            hạn
                                                                            quy
                                                                            định,{" "}
                                                                            <span
                                                                                style={{
                                                                                    fontWeight:
                                                                                        "bold",
                                                                                    color: "#222222",
                                                                                }}
                                                                            >
                                                                                tiền
                                                                                thưởng
                                                                                trả
                                                                                trước
                                                                            </span>{" "}
                                                                            sẽ
                                                                            bị
                                                                            thu
                                                                            hồi.
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <Col span={24}>
                                                                    <Empty
                                                                        image={
                                                                            "/vn/img/icon/img-no-record.svg"
                                                                        }
                                                                        className="big-empty-box"
                                                                        description={translate(
                                                                            "Không có thưởng nào"
                                                                        )}
                                                                    />
                                                                </Col>
                                                            )}
                                                        </div>
                                                    </TabPane>
                                                    <TabPane
                                                        tab={
                                                            <span
                                                                style={{
                                                                        fontSize:
                                                                            "14px",
                                                                }}
                                                            >
                                                                Có sẵn
                                                            </span>
                                                        }
                                                        key="3"
                                                    >
                                                        {aryGetableLstData?.length >
                                                        0 ? (
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "grid",
                                                                    gridTemplateColumns:
                                                                        "repeat(3, 1fr)",
                                                                    gap: "16px",
                                                                    // padding: "16px",
                                                                    marginTop:
                                                                        "16px",
                                                                }}
                                                            >
                                                                {aryGetableLstData.map(
                                                                    (
                                                                        item,
                                                                        index
                                                                    ) => (
                                                                        <AppliedClaimablePromotionCard
                                                                            key={
                                                                                index
                                                                            }
                                                                            item={
                                                                                item
                                                                            }
                                                                            updateAppliedHistory = {
                                                                                () => {
                                                                                    this.callbackForAppliedHistoryTab(
                                                                                        this.props.secondLayerTabKey
                                                                                    );
                                                                                }
                                                                            }
                                                                        />
                                                                    )
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <Col span={24}>
                                                                <Empty
                                                                    image={
                                                                        "/vn/img/icon/img-no-record.svg"
                                                                    }
                                                                    className="big-empty-box"
                                                                    description={translate(
                                                                        "Không có thưởng nào"
                                                                    )}
                                                                />
                                                            </Col>
                                                        )}
                                                    </TabPane>
                                                    <TabPane
                                                        tab={
                                                            <span
                                                                style={{
                                                                        fontSize:
                                                                        "14px",
                                                                }}
                                                            >
                                                                Hoàn thành
                                                            </span>
                                                        }
                                                        key="4"
                                                    >
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between",
                                                                alignItems:
                                                                    "flex-start",
                                                            }}
                                                        >
                                                            {/* Category Buttons */}
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    flexWrap:
                                                                        "wrap",
                                                                    gap: "12px",
                                                                    alignItems:
                                                                        "flex-start",
                                                                    width: "100%",
                                                                    marginBottom:
                                                                        "10px",
                                                                }}
                                                            >
                                                                {this.props?.balanceInfo?.balances.map(
                                                                    (
                                                                        category,
                                                                        i
                                                                    ) => (
                                                                        <button
                                                                            key={
                                                                                i
                                                                            }
                                                                            className={`category-tab ${
                                                                                category?.walletProductGroupCode ===
                                                                                this
                                                                                    .state
                                                                                    .AppliedHistoryTab4selectedCate
                                                                                    ? "active"
                                                                                    : ""
                                                                            }`}
                                                                            onClick={() => {
                                                                                let tabInfo =
                                                                                    this.firstTabs?.find(
                                                                                        (
                                                                                            tab
                                                                                        ) =>
                                                                                            tab.id ===
                                                                                            this
                                                                                                .completedIdOfFirstTabs
                                                                                    );
                                                                                console.log(
                                                                                    "🚀 Clicked tabInfo:",
                                                                                    tabInfo
                                                                                );
                                                                                this.handleCategoryChange(
                                                                                    category?.walletProductGroupCode,
                                                                                    tabInfo
                                                                                );
                                                                            }}
                                                                        >
                                                                            {category?.walletProductGroupId === 1 ? "Tất Cả" : category?.walletProductGroupName}
                                                                        </button>
                                                                    )
                                                                )}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    right: -18,
                                                                    top: 50,
                                                                    zIndex: 10,
                                                                }}
                                                            >
                                                                <Datepicker25
                                                                    onSearchClick={(
                                                                        year,
                                                                        month
                                                                    ) => {
                                                                        this.GetBonusHistory(
                                                                            {
                                                                                year,
                                                                                month,
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        {aryBonusAppliedHistory.length >
                                                        0 ? (
                                                            <div
                                                                style={{
                                                                    minHeight:
                                                                        "500px",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display:
                                                                            "grid",
                                                                        gridTemplateColumns:
                                                                            "repeat(3, 1fr)",
                                                                        gap: "16px",
                                                                        // padding: "16px",
                                                                        marginTop:
                                                                            "16px",
                                                                        minHeight:
                                                                            "130px",
                                                                    }}
                                                                >
                                                                    {aryBonusAppliedHistoryForDisplay.map(
                                                                        (
                                                                            item,
                                                                            index
                                                                        ) => {
                                                                            switch (
                                                                                item?.bonusGivenType
                                                                            ) {
                                                                                case "FreeSpin":
                                                                                    return (
                                                                                        <AppliedCompletePromotionCard.FreeSpin
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            item={
                                                                                                item
                                                                                            }
                                                                                        />
                                                                                    );
                                                                                case "RewardsPoint":
                                                                                    return (
                                                                                        <AppliedCompletePromotionCard.RewardPoint
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            item={
                                                                                                item
                                                                                            }
                                                                                        />
                                                                                    );
                                                                                default:
                                                                                    return (
                                                                                        <AppliedCompletePromotionCard
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            item={
                                                                                                item
                                                                                            }
                                                                                        />
                                                                                    );
                                                                            }
                                                                        }
                                                                    )}
                                                                </div>
                                                                {aryBonusAppliedHistory?.length >
                                                                    9 && (
                                                                    <Pagination
                                                                        className="general-pagination"
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                            marginTop:
                                                                                "20px",
                                                                        }}
                                                                        defaultCurrent={
                                                                            1
                                                                        }
                                                                        pageSize={
                                                                            9
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            let tabInfo =
                                                                                this.firstTabs?.find(
                                                                                    (
                                                                                        tab
                                                                                    ) =>
                                                                                        tab.id ===
                                                                                        this
                                                                                            .completedIdOfFirstTabs
                                                                                );
                                                                            console.log(
                                                                                "🚀 Appliedhistory page changed tabInfo:",
                                                                                tabInfo
                                                                            );
                                                                            this.handlePagination(
                                                                                tabInfo,
                                                                                e
                                                                            );
                                                                        }}
                                                                        total={
                                                                            aryBonusAppliedHistoryFiltered.length
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <Col span={24}>
                                                                <Empty
                                                                    image={
                                                                        "/vn/img/icon/OWTab4NoRecord.svg"
                                                                    }
                                                                    className="big-empty-box OW-Project-Empty"
                                                                    description={translate(
                                                                        "Hiện không có ghi nhận nào về Thưởng."
                                                                    )}
                                                                />
                                                            </Col>
                                                        )}
                                                    </TabPane>
                                                </Tabs>
                                            </div>
                                            <Newbie
                                                imgsrc="/vn/img/1wallet/newbie/MyBonus.avif"
                                                imgstyle={{
                                                    width: "calc(73% - 10px)",
                                                    height: "66%",
                                                    top: 200,
                                                    left: "14%",
                                                    transform:
                                                        "translateX(-2%)",
                                                }}
                                                btnstyle={{
                                                    bottom: "5%",
                                                    right: "50%",
                                                    transform:
                                                        "translateX(50%)",
                                                }}
                                            />
                                        </TabPane>

                                        <TabPane
                                            tab={<div>{translate("返水")}</div>}
                                            key="3"
                                        >
                                            <MyRebate />
                                        </TabPane>
                                    </Tabs>
                                </React.Fragment>
                            )}
                    </div>
                </div>

                {/*優惠詳情Modal*/}
                <Modal
                    className="theme-modal promotion-modal promotion-detail-modal promotion-detail"
                    title={translate("优惠详情")}
                    centered={true}
                    footer={false}
                    width={1120}
                    visible={isPromotionDetailModal}
                    onCancel={() => {
                        const url = new URL(window.location.href);
                        const params = new URLSearchParams(url.search);
                        this.props.setSelectedBonus(null);
                        this.setState({
                            isPromotionDetailModal: false,
                            selectedPromotionDetail: [],
                        });

                        if (params.has("jumpfrom") || params.has("id")) {
                            const url = new URL(window.location.href);
                            url.search = "";
                            window.history.replaceState(
                                null,
                                "",
                                url.toString()
                            );
                        }

                        this.props.setItemPromotionDetail({});
                    }}
                    destroyOnClose={true}
                >
                    <Provider store={store}>
                        <Spin
                            spinning={isRefreshingPromotion || getBonusLoading}
                            tip={translate("加载中")}
                        >
                            <iframe
                                id="tlc_game_ifame"
                                className="apply-promotion-detail-box"
                                style={{
                                    width: "100%",
                                    minHeight: "500px",
                                    border: "none",
                                }}
                                srcDoc={
                                    selectedPromotionDetail?.body
                                        ? `<style>
                                                html,body{margin:0;padding:0;}body{padding:15px;}
                                            </style>
                                            ${selectedPromotionDetail.body}
                                            <script>
                                                document.addEventListener('click', function(event) {
                                                    if(event.target.tagName === 'A') {
                                                        event.preventDefault();
                                                        var href = event.target.getAttribute('href');
                                                        window.top.location.href = href; // 讓主頁面進行跳轉
                                                    }
                                                });
                                            </script>`
                                        : ""
                                }
                            ></iframe>
                            {selectedPromotionDetail.body && (
                                <div className="button-box">
                                    <OneWalletPromotionPageButton
                                        withinTnCmodal={true}
                                        data={{
                                            ...selectedPromotionDetail,
                                            ...selectedPromotionItem,
                                        }}
                                        openApplicationModal={(
                                            config,
                                            params
                                        ) => {
                                            console.log(
                                                "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ promotionsApplicationModalVisible ~ selectedPromotionDetail",
                                                this.state
                                                    .promotionsApplicationModalVisible,
                                                config
                                            );
                                            console.log(
                                                "🚀 ~ file: Promotions.js ~ line 139 ~ Main ~ promotionsApplicationModalVisible ~ params",
                                                params
                                            );
                                            params = {
                                                showToastAfterSuccess:
                                                    this.showToastAfterSuccess,
                                                showToastAfterFailure:
                                                    this.showToastAfterFailure,
                                                ...params,
                                            };
                                            this.setState({
                                                // isPromotionDetailModal: false,
                                                promotionsApplicationModalProps:
                                                    params,
                                                promotionsApplicationModalConfig:
                                                    config,
                                                promotionsApplicationModalVisible: true,
                                            });
                                        }}
                                        onClose={() => {
                                            this.setState({
                                                promotionsApplicationModalVisible: false,
                                                promotionsApplicationModalConfig:
                                                    {},
                                                promotionsApplicationModalProps:
                                                    {},
                                            });
                                        }}
                                        openErrorModal={
                                            this.handleButtonErrorModal
                                        }
                                        showToastAfterSuccess={
                                            this.showToastAfterSuccess
                                        }
                                        showToastAfterFailure={
                                            this.showToastAfterFailure
                                        }
                                    />
                                </div>
                            )}
                        </Spin>
                    </Provider>
                </Modal>
                {/*優惠詳情Modal*/}
                <Modal
                    className="theme-modal promotion-modal promotion-detail-modal promotion-detail"
                    title={translate("优惠详情")}
                    centered={true}
                    footer={false}
                    width={1120}
                    visible={this.state.isAssignedClaimedBonusModal}
                    onCancel={() => {
                        this.setState({
                            isAssignedClaimedBonusModal: false,
                            selectedAssisnedClainBonus: {},
                        });
                    }}
                    destroyOnClose={true}
                >
                    <Provider store={store}>
                        <Spin
                            spinning={isRefreshingPromotion || getBonusLoading}
                            tip={translate("加载中")}
                        >
                            {this.state.selectedAssisnedClainBonus?.body ? (
                                <iframe
                                    id="tlc_game_ifame"
                                    className="apply-promotion-detail-box"
                                    style={{
                                        width: "100%",
                                        minHeight: "500px",
                                        border: "none",
                                    }}
                                    srcDoc={
                                        this.state.selectedAssisnedClainBonus
                                            ?.body
                                            ? `<style>
                                                html,body{margin:0;padding:0;}body{padding:15px;}
                                            </style>
                                            ${this.state.selectedAssisnedClainBonus.body}
                                            <script>
                                                document.addEventListener('click', function(event) {
                                                    if(event.target.tagName === 'A') {
                                                        event.preventDefault();
                                                        var href = event.target.getAttribute('href');
                                                        window.top.location.href = href; // 讓主頁面進行跳轉
                                                    }
                                                });
                                            </script>`
                                            : ""
                                    }
                                ></iframe>
                            ) : (
                                <>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center", // Centers horizontally
                                        alignItems: "center", // Centers vertically
                                        height: "100%", // Ensures it takes up the full parent height
                                    }}
                                >
                                    <Empty
                                        style={{
                                            height: "538px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                        image={"/vn/img/icon/OWTab4NoRecord.svg"}
                                        className="big-empty-box OW-Project-Empty"
                                        description={
                                            <div style={{ textAlign: "center", fontSize:"16px", fontWeight:400 }}> {/* Centers text inside */}
                                                Không có chi tiết nào, vui lòng 
                                                <span
                                                    type="link"
                                                    className="chatCs"
                                                    style={{
                                                        color: "#1890ff",
                                                        cursor: "pointer",
                                                        marginTop: "16px", // Adds spacing
                                                        margin: "0px 8px"
                                                    }}
                                                    onClick={() => {
                                                        piwikBonus.run8();
                                                        global.PopUpLiveChat();
                                                    }}
                                                >
                                                    {translate("在线客服")}
                                                </span>
                                                 để có thêm thông tin chi tiết
                                            </div>
                                        }
                                    />
                                </div>
                            </>                            
                            )}
                        </Spin>
                    </Provider>
                </Modal>
                <PromotionOneWalletModal
                    isVisible={this.state.promotionsApplicationModalVisible}
                    onClose={() => {
                        this.setState({
                            promotionsApplicationModalVisible: false,
                            promotionsApplicationModalConfig: {},
                            promotionsApplicationModalProps: {},
                        });
                    }}
                    config={this.state.promotionsApplicationModalConfig}
                    props={this.state.promotionsApplicationModalProps}
                />
                <PromotionOneWalletModal
                    isVisible={this.state.promotionErrorModalVisible}
                    onClose={() => {
                        this.setState({
                            promotionErrorModalVisible: false,
                            promotionErrorModalConfig: {},
                        });
                    }}
                    config={this.state.promotionErrorModalConfig}
                />
                {this.state?.toastMessageInfo?.show && (
                    <CustomizedToast
                        options={{
                            message: this.state?.toastMessageInfo?.content,
                            type: this.state?.toastMessageInfo?.type
                                ? this.state?.toastMessageInfo?.type
                                : "",
                            onClose: () =>
                                this.setState({
                                    toastMessageInfo: { show: false },
                                }),
                            duration: 3000,
                            classNames: "promotion-page promotion-toast",
                            wrapperClass: "OneWalletErrorToast",
                            messageClass: "OneWalletErrorToastMessage",
                            iconSrc: this.state?.toastMessageInfo?.iconSrc,
                        }}
                    />
                )}
                {/* Bonus優惠申請成功Modal */}
                <Modal
                    className="bonus-apply-success-modal"
                    visible={isTransferSuccessModal}
                    maskClosable={false}
                    destroyOnClose={true}
                    closable={false}
                    width={480}
                    centered
                    title={translate("优惠申请")}
                    okText={translate("查看促銷狀態")}
                    onOk={() => {
                        this.setState({
                            isTransferSuccessModal: false,
                            isTransferModal: false,
                            isPromotionDetailModal: false,
                        });
                        this.props.changeTab("2");
                    }}
                    cancelText={translate("关闭")}
                    onCancel={() => {
                        this.setState({
                            isTransferSuccessModal: false,
                            isTransferModal: false,
                            isPromotionDetailModal: false,
                        });
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "200px",
                            gap: "20px",
                        }}
                    >
                        <img
                            src={`${process.env.BASE_PATH}/img/icons/icon-checked.png`}
                            width={"45px"}
                            height={"45px"}
                        />
                        <div style={{ textAlign: "center", color: "black" }}>
                            {translate("转账及优惠申请成功")}
                        </div>
                    </div>
                </Modal>

                {/* Manual填寫申請資料 */}
                <Modal
                    className="theme-modal Form-modal promotion-modal manual-apply-modal manual-bonus-modal"
                    title={translate("优惠申请资料")}
                    centered={true}
                    destroyOnClose={true}
                    footer={false}
                    visible={isManualApplyModalVisible}
                    width={400}
                    onCancel={() =>
                        this.setState({
                            isManualApplyModalVisible: false,
                            remarks: "",
                        })
                    }
                >
                    <div>
                        <Spin
                            spinning={manualApplyFormSpinning}
                            size="large"
                            tip={translate("加载中")}
                        >
                            <div className="Formbox">
                                <h3>{selectedPromotionDetail.promoTitle}</h3>
                                <div className="user-info-box">
                                    <Input
                                        addonBefore={translate("用户名(大写)")}
                                        defaultValue={
                                            this.state.memberInfo.userName
                                        }
                                        disabled
                                    />
                                    <div>
                                        <Input
                                            addonBefore={translate("邮箱")}
                                            defaultValue={mailConversion(
                                                this.state.memberInfo
                                                    ?.isVerifiedEmail?.[0] ?? ""
                                            )}
                                            disabled
                                        />
                                        <p
                                            style={{
                                                fontWeight: "400",
                                                fontSize: "12px",
                                                lineHeight: "16px",
                                            }}
                                        >
                                            {translate(
                                                "如果您想更新您的电子邮件地址，请联系我们的"
                                            )}
                                            <span
                                                style={{
                                                    color: "#00A6FF",
                                                }}
                                                onClick={() =>
                                                    global.PopUpLiveChat()
                                                }
                                            >
                                                &nbsp; {translate("客服")}
                                            </span>
                                        </p>
                                    </div>
                                    <div>
                                        <Input
                                            addonBefore={translate(
                                                "联系电话(大写)"
                                            )}
                                            defaultValue={numberConversion(
                                                this.state.memberInfo
                                                    ?.isVerifiedPhone?.[0] ?? ""
                                            )}
                                            disabled
                                        />
                                        <p
                                            style={{
                                                fontWeight: "400",
                                                fontSize: "12px",
                                                lineHeight: "16px",
                                            }}
                                        >
                                            {translate(
                                                "如果您想更新您的电话号码，请联系我们的"
                                            )}
                                            <span
                                                style={{
                                                    marginLeft: "5px",
                                                    color: "#00A6FF",
                                                }}
                                                onClick={() =>
                                                    global.PopUpLiveChat()
                                                }
                                            >
                                                &nbsp;{translate("客服")}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="remarks-box">
                                    <label
                                        style={{
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {translate("备注")}
                                    </label>
                                    <textarea
                                        cols={5}
                                        rows={3}
                                        maxLength={this.state.remarksMaxLength}
                                        value={this.state.remarks}
                                        onChange={(E) =>
                                            this.handleTextareaChange(E)
                                        }
                                        required={true}
                                    />
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            color: "#888",
                                            fontSize: "12px",
                                        }}
                                    >
                                        <span>{`${this.state.remarks.length}/${this.state.remarksMaxLength}`}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="ps_bottom">
                                <button
                                    // disabled={!this.state.remarks.trim().length}
                                    className="button"
                                    onClick={() => {
                                        // this.getIsManualApplicantFull(
                                        //     selectedPromotionDetail.promoId
                                        // );
                                        this.PromApplications();
                                    }}
                                >
                                    {selectedPromotionDetail.actionType ===
                                    "LiveChat"
                                        ? translate("在线客服")
                                        : translate("提交")}
                                </button>
                            </div>
                        </Spin>
                    </div>
                </Modal>

                {/* Manual已提交資料Modal */}
                <AppliedDataModal
                    isVisible={isManualAppliedDataVisible}
                    onCancel={() => {
                        this.setState({ isManualAppliedDataVisible: false });
                    }}
                    appliedItem={appliedPromotion}
                />

                {/* 轉帳Modal */}
                {console.log(
                    "檢查開啟轉帳Modal條件",
                    "\n",
                    "fromWalletList",
                    fromWalletList,
                    "\n",
                    "currentMoney",
                    currentMoney,
                    "\n",
                    "toWalletName",
                    toWalletName,
                    "\n",
                    "selectedPromotionDetail",
                    selectedPromotionDetail,
                    "\n",
                    "WalletBonusProfile",
                    WalletBonusProfile,
                    "\n",
                    "selectedPromotionItem?.bonusData",
                    selectedPromotionItem?.bonusData,
                    "porps",
                    this.props,
                    "states",
                    this.state
                )}
                {fromWalletList?.length &&
                    currentMoney?.balanceList?.length &&
                    toWalletName &&
                    selectedPromotionDetail && (
                        <>
                            <TransferModal
                                isOneClickTransfer={isOneClickTransfer}
                                visible={isTransferModal}
                                onCancel={() => {
                                    this.setState({ isTransferModal: false });
                                }}
                                moneyModalLoading={moneyModalLoading} //控制提交時Loading
                                isRefreshingBalance={isRefreshingBalance} //控制更新錢包時Loading
                                fromWalletList={fromWalletList} //來源帳戶清單(無餘額)
                                currentMoneyList={currentMoney.balanceList} //各帳戶餘額清單
                                toWalletName={toWalletName} //目的帳戶名稱
                                selectedPromotionDetail={
                                    selectedPromotionDetail
                                }
                                WalletBonusProfile={
                                    selectedPromotionItem?.bonusData || {}
                                }
                                onTransferSubmit={this.handleTransfer}
                                onDepositSubmit={() => {
                                    this.setState({ isWalletModal: true });
                                }}
                            />
                            {this.props.memberInfo?.active && (
                                <SelfExclusionModal
                                    ModalType={1}
                                    OpenModalUrl="Transfer"
                                    afterCloseModal={() => {
                                        this.setState({
                                            isTransferModal: false,
                                        });
                                        Router.push("/");
                                    }}
                                />
                            )}
                        </>
                    )}

                {/* 财务管理 */}
                <Modal
                    title={translate("钱包")}
                    footer={null}
                    maskClosable={!this.state.isModalLoad}
                    keyboard={!this.state.isModalLoad}
                    width={750}
                    className="wallet-modal"
                    visible={this.state.isWalletModal}
                    destroyOnClose={true}
                    onCancel={() => {
                        this.setState({ isWalletModal: false });
                    }}
                >
                    <Provider store={store}>
                        <Spin
                            className={this.state.isModalLoad ? "show" : "hide"}
                            size="large"
                            tip={translate("加载中")}
                        />
                        {this.state.modalTabKey !== "" ? (
                            <DynamicWallet
                                dialogTabKey={this.state.modalTabKey}
                                getBalance={this.getBalance}
                                balanceList={this.state.balanceList}
                                onCancel={(type) => {
                                    this.setState({ isWalletModal: false });
                                    if (type && type == "ToHome") {
                                        Router.push("/");
                                    }
                                }}
                                visible={this.state.walletVisible}
                                goUserCenter={(key) => {
                                    const path = `/me/${pathNameList[key]}`;
                                    if (path) {
                                        this.props.changeUserCenterTabKey(key);
                                        Router.push(path);
                                    }
                                }}
                                setModalTabKey={(v, run) =>
                                    this.setState({ modalTabKey: v }, () => {
                                        typeof run === "function" && run();
                                    })
                                }
                                setLoading={(v) =>
                                    this.setState({ isModalLoad: v })
                                }
                                bonusDetail={selectedPromotionDetail}
                            />
                        ) : null}
                    </Provider>
                </Modal>
                {/* Manual優惠人數過多Modal */}
                <Modal
                    className="apply-fail-modal"
                    visible={isManualFullOfApplicantsModal}
                    width={400}
                    centered
                    destroyOnClose={true}
                    cancelButtonProps={{ style: { display: "none" } }}
                    okText={translate("优惠")}
                    onOk={() => {
                        this.setState({
                            isManualFullOfApplicantsModal: false,
                            isPromotionDetailModal: false,
                            isManualApplyModalVisible: false,
                            remarks: "",
                            selectedPromotionDetail: {},
                        });
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "300px",
                            gap: "12px",
                        }}
                    >
                        <img
                            src={`${process.env.BASE_PATH}/img/promotions/error.png`}
                            width={"60px"}
                            height={"60px"}
                        />
                        <span
                            style={{
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "black",
                                marginTop: "10px",
                            }}
                        >
                            {translate("无法领取奖励")}
                        </span>
                        <div
                            style={{
                                textAlign: "center",
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "black",
                            }}
                        >
                            {translate(
                                "抱歉，此促销活动目前已超额认购，请尝试注册其他促销活动。"
                            )}
                        </div>
                    </div>
                </Modal>

                {/* Manual優惠申請Result */}
                <Modal
                    title={null}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={!this.state.isModalLoad}
                    keyboard={!this.state.isModalLoad}
                    width={400}
                    className="manual-result-modal"
                    visible={this.state.isShowManualResultModal}
                    centered={true}
                >
                    <Spin
                        className={this.state.isModalLoad ? "show" : "hide"}
                        size="large"
                        tip={translate("加载中")}
                    />
                    <div className="result-content-box">
                        <img
                            src={`${process.env.BASE_PATH}/img/promotions/${
                                this.state.isManualApplySuccess
                                    ? "success"
                                    : "error"
                            }.png`}
                        />
                        <p className="text-status">
                            {this.state.isManualApplySuccess
                                ? translate("报名参加促销活动")
                                : translate("无法领取奖励")}
                        </p>
                        <p className="text-desription">
                            {this.state.isManualApplySuccess
                                ? translate(
                                      "您已成功注册促销，请在“促销已加入”页面查看促销状态"
                                  )
                                : manualResultMessage}
                        </p>
                        <div className="button-box">
                            {this.state.isManualApplySuccess ? (
                                <>
                                    <button
                                        onClick={() => {
                                            this.setState({
                                                isShowManualResultModal: false,
                                                isManualApplyModalVisible: false,
                                                isPromotionDetailModal: false,
                                            });
                                        }}
                                    >
                                        {translate("关闭")}
                                    </button>
                                    <button
                                        onClick={() => {
                                            this.props.changeTab("2");
                                            this.setState({
                                                isShowManualResultModal: false,
                                                isManualApplyModalVisible: false,
                                                isPromotionDetailModal: false,
                                            });
                                        }}
                                    >
                                        {translate("查看促銷狀態")}
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        onClick={() => {
                                            global.PopUpLiveChat();
                                        }}
                                    >
                                        {translate("在线客服")}
                                    </button>
                                    <button
                                        onClick={() => {
                                            this.textareaValue = "";
                                            this.setState({
                                                remarks: "",
                                                isShowManualResultModal: false,
                                                isManualApplyModalVisible: false,
                                            });
                                        }}
                                    >
                                        {translate("关闭")}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </Modal>

                {/* 餘額不足Modal */}
                <Modal
                    title={translate("余额不足")}
                    destroyOnClose={true}
                    maskClosable={!this.state.isModalLoad}
                    keyboard={!this.state.isModalLoad}
                    width={400}
                    centered
                    className="promotion-modal general-modal deposit-warning-modal"
                    visible={this.state.isDepositWarningModel}
                    onCancel={() => {
                        this.setState({ isDepositWarningModel: false });
                    }}
                    cancelText={translate("取消")}
                    okText={translate("存款")}
                    onOk={() => {
                        this.setState({ isWalletModal: true });
                    }}
                >
                    <Spin
                        className={this.state.isModalLoad ? "show" : "hide"}
                        size="large"
                        tip={translate("加载中")}
                    />
                    <div className="result-content-box">
                        <p>
                            {translate(
                                "抱歉，目前您的余额不足以参与本次活动，请“充值”并继续参与。"
                            )}
                        </p>
                    </div>
                </Modal>
                <RealyName
                    type="promotion"
                    // 类型为promotion必须传递下一步方法
                    nextStep={() => {
                        this.Application(this.finishRealyNameNextStepInfo);
                    }}
                    onCancel={() => this.setState({ isOpenRealyName: false })}
                    onChangeName={(v) => this.setState({ realyName: v })}
                    realyNameVisible={this.state.isOpenRealyName}
                />
                {/* 紧急公告弹窗 */}
                {this.props.isDisableFromSelfExclude !== null &&
                    !this.props.isDisableFromSelfExclude && (
                        <Announcement
                            isDisableFromSelfExclude={
                                this.props.isDisableFromSelfExclude
                            }
                        />
                    )}
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        topTabIndex: state.promotion.topTabIndex,
        categories: state.promotion.categories,
        promotions: state.promotion.promotions,
        appliedPromotions: state.promotion.appliedPromotions,
        itemPromotionDetail: state.promotion.itemPromotionDetail,
        isDisableFromSelfExclude: state.userCenter.isDisableFromSelfExclude, // Map the state to props
        memberInfo: state.userCenter.memberInfo,
        isFetching: state.promotion.isFetching,
        smarticoVisible: state.game.smarticoVisible,
        backPromotionPage: state.promotion.backPromotionPage,
        toggleOnOff: state.userCenter.toggleOnOff,
        firstLayerTabKey: state.promotion.promtionFisrtLayerTab,
        secondLayerTabKey: state.promotion.promotionSecondLayerTab,
        balanceInfo: state.userCenter.balanceInfo,
        useCentralPayment: state.centralPaymentReducer.useCentralPayment,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        changeTab: (i) => {
            dispatch(changeTabAction(i));
        },
        setSelectedBonus: (bonusItem) => {
            dispatch(promotionActions.setSelectedBonus(bonusItem));
        },
        setOWSelectedBonus: (bonusItem) => {
            dispatch(promotionActions.setOWSelectedBonus(bonusItem));
        },
        setCategories: (result) => {
            dispatch(promotionActions.setCategories(result));
        },
        setPromotions: () => {
            dispatch(getPromotionListAction());
        },
        updateBonusPromotionHistory: (promoId) => {
            dispatch(updateBonusPromotionHistoryAction(promoId));
        },
        getAllPromotionRelatedData: () => {
            dispatch(getAllPromotionRelatedDataAction());
        },
        changeUserCenterTabKey: (tabkey) => {
            dispatch(userCenterActions.changeUserCenterTabKey(tabkey));
        },
        setItemPromotionDetail: (v) => {
            dispatch(promotionActions.setItemPromotionDetail(v));
        },
        setSmarticoContinue: (isFromSmarticoLogin) => {
            dispatch(setSmarticoLoginContinue(isFromSmarticoLogin));
        },
        fetchMemberSelfExlusionStatus: () =>
            dispatch(fetchMemberSelfExlusionStatus()),
        setBackPromotionPage: (status) => {
            dispatch(promotionActions.setBackPromotionPage(status));
        },
        setPromotionSecondLayerTab: (state) => {
            dispatch(promotionActions.setPromotionSecondLayerTab(state));
        },
        dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
